/* eslint-disable max-len */
import { Element, Timeline } from '@svgdotjs/svg.js';
import * as _ from 'lodash';

/**
 * Defines an animation function given a SVG element and a svg.js timeline.
 *
 * The return value of the function is the length of time for the Runner.
 */
export interface BlobAnimation {
  (blobEl: Element, timeline: Timeline): number;
}

export interface BlobAnimationStep {
  start: number;
  time: number;
  d?: string;
  attr?: {[key: string]: any};
  move?: {x: number, y: number};
}

const createAnimationForElement = (blobEl: Element, timeline: Timeline, steps: BlobAnimationStep[], id: string) => {
  const el = blobEl.findOne(`#${id}`) as any;
  el.timeline(timeline);
  // Commenting out to stop console error. Fix in 7062
  // steps.forEach((step: BlobAnimationStep) => {
  //   const animatedEl = el
  //     // duration, delay, "when".
  //     .animate(step.time, step.start, 'now')
  //     .ease('<>');
  //   if (step.d) {
  //     animatedEl.plot(step.d);
  //   }
  //   if (step.attr) {
  //     animatedEl.attr(step.attr);
  //   }
  //   if (step.move) {
  //     animatedEl.dmove(step.move.x, step.move.y);
  //   }
  // });
};

/** Blinks */
export const blink: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const animations: {[key: string]: BlobAnimationStep[]} = {
    leftEyeWhite: [
      {
        start: 0,
        time: 200,
        d: 'M559.3 388.08518021935475, C 543.1999999999999 379.93497391523056, 463.19999999999993 385.8942645462031, 492.79999999999995 395.56934815884085, C 517.7 401.6863847182804, 584.4 398.2159742920081, 559.3 388.08518021935475 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M559.3 351.5, C 543.1999999999999 305, 463.19999999999993 339, 492.79999999999995 394.2, C 517.7 429.1, 584.4 409.3, 559.3 351.5 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1100,
        time: 200,
        d: 'M559.3 382.4463081656343, C 543.1999999999999 371.57865073090437, 463.19999999999993 379.52489487672847, 492.79999999999995 392.42585596053686, C 517.7 400.582441863162, 584.4 395.9549232135351, 559.3 382.4463081656343 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1300,
        time: 200,
        d: 'M559.3 351.5, C 543.1999999999999 305, 463.19999999999993 339, 492.79999999999995 394.2, C 517.7 429.1, 584.4 409.3, 559.3 351.5 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightEyeWhite: [
      {
        start: 0,
        time: 200,
        d: 'M735.9 401.00355865164977, C 759.3 393.0128371098105, 703.3 379.7881929580664, 662.8 391.4146928014427, C 633.9 401.00355865164977, 702.1 410.49254048258405, 735.9 401.00355865164977 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M735.9 403.8, C 759.3 363.8, 703.3 297.6, 662.8 355.8, C 633.9 403.8, 702.1 451.3, 735.9 403.8 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1100,
        time: 200,
        d: 'M735.9 394.71380184302365, C 759.3 386.80965891840793, 703.3 373.72830237816896, 662.8 385.22883033348467, C 633.9 394.71380184302365, 702.1 404.09997156600474, 735.9 394.71380184302365 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1300,
        time: 200,
        d: 'M735.9 403.8, C 759.3 363.8, 703.3 297.6, 662.8 355.8, C 633.9 403.8, 702.1 451.3, 735.9 403.8 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    leftIris: [
      {
        start: 0,
        time: 200,
        d: 'M571.3 389.27860890600294, C 567.8 379.411112148889, 499.09999999999997 383.84711954058264, 509.19999999999993 392.2126610390918, C 523.5 399.0413180869352, 577.9 397.347252271997, 571.3 389.27860890600294 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M571.3 366.8, C 567.8 310.3, 499.09999999999997 335.7, 509.19999999999993 383.6, C 523.5 422.7, 577.9 413, 571.3 366.8 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1100,
        time: 200,
        d: 'M571.3 386.4226146550823, C 567.8 371.97176398935505, 499.09999999999997 378.46825260722176, 509.19999999999993 390.71950476453765, C 523.5 400.7200049597578, 577.9 398.23906245608424, 571.3 386.4226146550823 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1300,
        time: 200,
        d: 'M571.3 366.8, C 567.8 310.3, 499.09999999999997 335.7, 509.19999999999993 383.6, C 523.5 422.7, 577.9 413, 571.3 366.8 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightIris: [
      {
        start: 0,
        time: 200,
        d: 'M743.2 394.3360239081912, C 752.1 385.5251001669388, 678.7 383.57962247954555, 673.2 393.355245900497, C 671.9 399.4810888665867, 736.8 400.7834334341806, 743.2 394.3360239081912 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M743.2 387.2, C 752.1 332.4, 678.7 320.29999999999995, 673.2 381.09999999999997, C 671.9 419.2, 736.8 427.3, 743.2 387.2 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1100,
        time: 200,
        d: 'M743.2 392.1127660326336, C 752.1 378.70692404126703, 678.7 375.74687498842866, 673.2 390.62050989855817, C 671.9 399.9409949327017, 736.8 401.9225153730315, 743.2 392.1127660326336 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1300,
        time: 200,
        d: 'M743.2 387.2, C 752.1 332.4, 678.7 320.29999999999995, 673.2 381.09999999999997, C 671.9 419.2, 736.8 427.3, 743.2 387.2 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    leftPupil: [
      {
        start: 0,
        time: 200,
        d: 'M553.2 375.3349069518154, C 552.9000000000001 374.16712602631196, 551.7 372.9993451008087, 549.7 372.2640756291953, C 545.6 370.6637832498017, 539.9000000000001 371.00979241291384, 536.7 372.6965870830855, C 535.5 373.2588519731427, 534.7 373.9508702993669, 534.3000000000001 374.6428886255912, C 534.0000000000001 374.98889778870335, 533.8000000000001 375.3349069518154, 533.8000000000001 375.7241672603166, C 533.8000000000001 376.28643215037374, 533.9000000000001 376.7621947496529, 534.3000000000001 377.23795734893207, C 534.9000000000001 378.4057382744355, 536.4000000000001 379.48701690916084, 539.1 380.1357840899962, C 544.3000000000001 381.43331845166665, 551.1 380.3952909623303, 552.9 377.8867245297673, C 553.1999999999999 377.4542130758772, 553.3 376.9784504765979, 553.3 376.50268787731886, C 553.4 376.1134275688177, 553.4 375.7241672603166, 553.2 375.3349069518154 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M553.2 368.3, C 552.9000000000001 365.6, 551.7 362.90000000000003, 549.7 361.2, C 545.6 357.5, 539.9000000000001 358.3, 536.7 362.2, C 535.5 363.5, 534.7 365.09999999999997, 534.3000000000001 366.7, C 534.0000000000001 367.5, 533.8000000000001 368.3, 533.8000000000001 369.2, C 533.8000000000001 370.5, 533.9000000000001 371.59999999999997, 534.3000000000001 372.7, C 534.9000000000001 375.4, 536.4000000000001 377.9, 539.1 379.4, C 544.3000000000001 382.4, 551.1 380, 552.9 374.2, C 553.1999999999999 373.2, 553.3 372.09999999999997, 553.3 371, C 553.4 370.1, 553.4 369.2, 553.2 368.3 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1100,
        time: 200,
        d: 'M553.2 376.69816745985474, C 552.9000000000001 375.8273078395274, 551.7 374.9564482192001, 549.7 374.40812919899406, C 545.6 373.2147289785455, 539.9000000000001 373.4727614586425, 536.7 374.7306697991153, C 535.5 375.14997257927286, 534.7 375.6660375394668, 534.3000000000001 376.18210249966074, C 534.0000000000001 376.4401349797578, 533.8000000000001 376.69816745985474, 533.8000000000001 376.98845399996384, C 533.8000000000001 377.40775678012136, 533.9000000000001 377.76255144025475, 534.3000000000001 378.1173461003881, C 534.9000000000001 378.98820572071537, 536.4000000000001 379.7945572210184, 539.1 380.27836812120023, C 544.3000000000001 381.245989921564, 551.1 380.471892481273, 552.9 378.6011570005699, C 553.1999999999999 378.2786164004487, 553.3 377.9238217403153, 553.3 377.569027080182, C 553.4 377.27874054007293, 553.4 376.98845399996384, 553.2 376.69816745985474 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1300,
        time: 200,
        d: 'M553.2 368.3, C 552.9000000000001 365.6, 551.7 362.90000000000003, 549.7 361.2, C 545.6 357.5, 539.9000000000001 358.3, 536.7 362.2, C 535.5 363.5, 534.7 365.09999999999997, 534.3000000000001 366.7, C 534.0000000000001 367.5, 533.8000000000001 368.3, 533.8000000000001 369.2, C 533.8000000000001 370.5, 533.9000000000001 371.59999999999997, 534.3000000000001 372.7, C 534.9000000000001 375.4, 536.4000000000001 377.9, 539.1 379.4, C 544.3000000000001 382.4, 551.1 380, 552.9 374.2, C 553.1999999999999 373.2, 553.3 372.09999999999997, 553.3 371, C 553.4 370.1, 553.4 369.2, 553.2 368.3 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightPupil: [
      {
        start: 0,
        time: 200,
        d: 'M719 381.71661845813804, C 719.5 381.34727785021903, 719.8 380.91078440449667, 719.8 380.50786737767595, C 719.9 378.9633521081966, 716.5 377.5867189332259, 712.0999999999999 377.2173783253069, C 710.1999999999999 377.0494962307983, 708.3999999999999 377.11664906860176, 706.8 377.35168400091385, C 704 377.5531425143241, 701.5 378.22467089235863, 700.1999999999999 379.13123420270523, C 698.1999999999999 380.5414437965776, 699.1999999999999 382.18668832276217, 702.5999999999999 383.2611337276174, C 706.0999999999999 384.36915555137426, 711.8999999999999 384.6713433214898, 715.6999999999999 383.5297450788311, C 716.4999999999999 383.29471014651904, 717.0999999999999 383.02609879530524, 717.5999999999999 382.72391102518975, C 717.6999999999999 382.6567581873863, 717.8999999999999 382.5896053495829, 717.9999999999999 382.5560289306811, C 718.4 382.25384116056557, 718.7 381.98522980935184, 719 381.71661845813804 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M719 376.7, C 719.5 375.59999999999997, 719.8 374.3, 719.8 373.09999999999997, C 719.9 368.49999999999994, 716.5 364.4, 712.0999999999999 363.29999999999995, C 710.1999999999999 362.79999999999995, 708.3999999999999 362.99999999999994, 706.8 363.69999999999993, C 704 364.29999999999995, 701.5 366.29999999999995, 700.1999999999999 368.99999999999994, C 698.1999999999999 373.19999999999993, 699.1999999999999 378.09999999999997, 702.5999999999999 381.29999999999995, C 706.0999999999999 384.59999999999997, 711.8999999999999 385.49999999999994, 715.6999999999999 382.09999999999997, C 716.4999999999999 381.4, 717.0999999999999 380.59999999999997, 717.5999999999999 379.7, C 717.6999999999999 379.5, 717.8999999999999 379.3, 717.9999999999999 379.2, C 718.4 378.3, 718.7 377.5, 719 376.7 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1100,
        time: 200,
        d: 'M719 382.0862682210892, C 719.5 381.77076628424606, 719.8 381.39790035888603, 719.8 381.0537164277845, C 719.9 379.73434469189516, 716.5 378.5583829272981, 712.0999999999999 378.24288099045503, C 710.1999999999999 378.0994710191627, 708.3999999999999 378.15683500767966, 706.8 378.3576089674889, C 704 378.5297009330397, 701.5 379.10334081820895, 700.1999999999999 379.87775466318743, C 698.1999999999999 381.0823984220429, 699.1999999999999 382.48781614070765, 702.5999999999999 383.4056399569785, C 706.0999999999999 384.35214576750775, 711.8999999999999 384.610283715834, 715.6999999999999 383.63509591104616, C 716.4999999999999 383.4343219512369, 717.0999999999999 383.2048659971691, 717.5999999999999 382.94672804884306, C 717.6999999999999 382.8893640603261, 717.8999999999999 382.83200007180926, 717.9999999999999 382.8033180775508, C 718.4 382.54518012922455, 718.7 382.31572417515684, 719 382.0862682210892 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1300,
        time: 200,
        d: 'M719 376.7, C 719.5 375.59999999999997, 719.8 374.3, 719.8 373.09999999999997, C 719.9 368.49999999999994, 716.5 364.4, 712.0999999999999 363.29999999999995, C 710.1999999999999 362.79999999999995, 708.3999999999999 362.99999999999994, 706.8 363.69999999999993, C 704 364.29999999999995, 701.5 366.29999999999995, 700.1999999999999 368.99999999999994, C 698.1999999999999 373.19999999999993, 699.1999999999999 378.09999999999997, 702.5999999999999 381.29999999999995, C 706.0999999999999 384.59999999999997, 711.8999999999999 385.49999999999994, 715.6999999999999 382.09999999999997, C 716.4999999999999 381.4, 717.0999999999999 380.59999999999997, 717.5999999999999 379.7, C 717.6999999999999 379.5, 717.8999999999999 379.3, 717.9999999999999 379.2, C 718.4 378.3, 718.7 377.5, 719 376.7 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    eyelids: [
      {
        start: 0,
        time: 200,
        attr: { opacity: 1 },
      },
      {
        start: 200,
        time: 200,
        attr: { opacity: 0 },
      },
      {
        start: 1100,
        time: 200,
        attr: { opacity: 1 },
      },
      {
        start: 1300,
        time: 200,
        attr: { opacity: 0 },
      },
    ]
  };

  _.forEach(animations, (times, id) => createAnimationForElement(blobEl, timeline, times, id));

  return 1500;
};

export const animateSticker: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const elements = blobEl.find('#sticker .animate');
  if (elements.length > 0) {
    elements.forEach((el: any) => {
      el.timeline(timeline);

      // Example of an element within a sticker that has the "spin" class.
      if (el.hasClass('spin')) {
        el
          .animate(250, 0, 'now')
          .ease('<>')
          .transform({ rotate: 180 })
          .animate(250, 0, 'now')
          .transform({ rotate: 180 })
          .loop(2);
      }
    });
    return 500;
  }

  return null;
};

export const whimsicalVanish: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const elements = blobEl.find('g');
  elements.forEach((el: any) => {
    el.timeline(timeline);
    if (el.attr('id') === 'shadow') {
      el
        .animate(100, 0, 'now')
        .opacity(0)
        .animate(100, 600, 'after')
        .opacity(1);
    } else {
      el
        .animate(500, 0, 'now')
        .ease('<')
        .transform({ translateY: 15, scale: .15 })
        .animate(500, 0, 'after')
        .transform({ scale: 1, translateY: 0 });
    }
  });
  return 800;
};

/** bloat silliness: scale up all the graphic elements equally. */
export const whimsicalBloat: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const elements = blobEl.find('g');
  elements.forEach((el: any) => {
    el.timeline(timeline);
    el
      .animate(500, 0, 'now')
      .ease('>')
      .transform({ scale: 1.25 })
      .reverse();
  });
  return 1000;
};

/** Goofy eyes */
export const spinEyes: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const leftWhite = blobEl.findOne('#leftEyeWhite') as any;
  const rightWhite = blobEl.findOne('#rightEyeWhite') as any;
  const leftIris = blobEl.findOne('#leftIris') as any;
  const rightIris = blobEl.findOne('#rightIris') as any;
  const leftPupil = blobEl.findOne('#leftPupil') as any;
  const rightPupil = blobEl.findOne('#rightPupil') as any;

  leftWhite.timeline(timeline);
  rightWhite.timeline(timeline);
  leftPupil.timeline(timeline);
  leftIris.timeline(timeline);
  rightPupil.timeline(timeline);
  rightIris.timeline(timeline);
  const leftIrisPosition = [leftIris.x(), leftIris.y()];
  const leftPupilPosition = [leftPupil.x(), leftPupil.y()];

  leftWhite
    .animate(500, 0, 'now')
    .ease('<>')
    .during((animationPosition: number) => {
      const p = leftWhite.pointAt(animationPosition * leftWhite.length());
      leftIris.center(p.x, p.y);
      leftPupil.center(p.x, p.y);
    })
    .loop(3)
    .after(() => {
      leftIris
        .animate(100, 0, 'now')
        .ease('>')
        .move(...leftIrisPosition);
      leftPupil
        .animate(100, 0, 'now')
        .ease('>')
        .move(...leftPupilPosition);
    });

  const rightIrisPosition = [rightIris.x(), rightIris.y()];
  const rightPupilPosition = [rightPupil.x(), rightPupil.y()];

  rightWhite
    .animate(500, 0, 'now')
    .ease('<>')
    .reverse()
    .during((animationPosition) => {
      const p = rightWhite.pointAt(animationPosition * rightWhite.length());
      rightIris.center(p.x, p.y);
      rightPupil.center(p.x, p.y);
    })
    .loop(3)
    .after(() => {
      rightIris
        .animate(100, 0, 'now')
        .ease('>')
        .move(...rightIrisPosition);
      rightPupil
        .animate(100, 0, 'now')
        .ease('>')
        .move(...rightPupilPosition);
    });

  return 1800;
};

/** Spins eyebrows a couple of times per click. */
export const spinEyebrows: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const eyebrows = blobEl.find('#eyebrows path') as any[];

  eyebrows.forEach((el) => {
    el.timeline(timeline);
    el
      .animate(250, 0, 'now')
      .ease('<>')
      .transform({ rotate: 180, scale: 5 })
      .animate(250, 0, 'now')
      .transform({ rotate: 180, scale: 5 })
      .after(() => {
        el
          .animate(250, 0, 'now')
          .transform({ transform: 180, scale: 1 });
      });
  });

  return 1000;
};

/** Flaps arms, blinks, and opens mouth. */
export const flapArms: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const animations: {[key: string]: BlobAnimationStep[]} = {
    leftEyeWhite: [
      {
        start: 0,
        time: 200,
        d: 'M559.3 388.08518021935475, C 543.1999999999999 379.93497391523056, 463.19999999999993 385.8942645462031, 492.79999999999995 395.56934815884085, C 517.7 401.6863847182804, 584.4 398.2159742920081, 559.3 388.08518021935475 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 2200,
        time: 200,
        d: 'M559.3 351.5, C 543.1999999999999 305, 463.19999999999993 339, 492.79999999999995 394.2, C 517.7 429.1, 584.4 409.3, 559.3 351.5 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightEyeWhite: [
      {
        start: 0,
        time: 200,
        d: 'M735.9 401.00355865164977, C 759.3 393.0128371098105, 703.3 379.7881929580664, 662.8 391.4146928014427, C 633.9 401.00355865164977, 702.1 410.49254048258405, 735.9 401.00355865164977 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 2200,
        time: 200,
        d: 'M735.9 403.8, C 759.3 363.8, 703.3 297.6, 662.8 355.8, C 633.9 403.8, 702.1 451.3, 735.9 403.8 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    leftIris: [
      {
        start: 0,
        time: 200,
        d: 'M571.3 389.27860890600294, C 567.8 379.411112148889, 499.09999999999997 383.84711954058264, 509.19999999999993 392.2126610390918, C 523.5 399.0413180869352, 577.9 397.347252271997, 571.3 389.27860890600294 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 2200,
        time: 200,
        d: 'M571.3 366.8, C 567.8 310.3, 499.09999999999997 335.7, 509.19999999999993 383.6, C 523.5 422.7, 577.9 413, 571.3 366.8 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightIris: [
      {
        start: 0,
        time: 200,
        d: 'M743.2 394.3360239081912, C 752.1 385.5251001669388, 678.7 383.57962247954555, 673.2 393.355245900497, C 671.9 399.4810888665867, 736.8 400.7834334341806, 743.2 394.3360239081912 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 2200,
        time: 200,
        d: 'M743.2 387.2, C 752.1 332.4, 678.7 320.29999999999995, 673.2 381.09999999999997, C 671.9 419.2, 736.8 427.3, 743.2 387.2 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    leftPupil: [
      {
        start: 0,
        time: 200,
        d: 'M553.2 375.3349069518154, C 552.9000000000001 374.16712602631196, 551.7 372.9993451008087, 549.7 372.2640756291953, C 545.6 370.6637832498017, 539.9000000000001 371.00979241291384, 536.7 372.6965870830855, C 535.5 373.2588519731427, 534.7 373.9508702993669, 534.3000000000001 374.6428886255912, C 534.0000000000001 374.98889778870335, 533.8000000000001 375.3349069518154, 533.8000000000001 375.7241672603166, C 533.8000000000001 376.28643215037374, 533.9000000000001 376.7621947496529, 534.3000000000001 377.23795734893207, C 534.9000000000001 378.4057382744355, 536.4000000000001 379.48701690916084, 539.1 380.1357840899962, C 544.3000000000001 381.43331845166665, 551.1 380.3952909623303, 552.9 377.8867245297673, C 553.1999999999999 377.4542130758772, 553.3 376.9784504765979, 553.3 376.50268787731886, C 553.4 376.1134275688177, 553.4 375.7241672603166, 553.2 375.3349069518154 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 2200,
        time: 200,
        d: 'M553.2 368.3, C 552.9000000000001 365.6, 551.7 362.90000000000003, 549.7 361.2, C 545.6 357.5, 539.9000000000001 358.3, 536.7 362.2, C 535.5 363.5, 534.7 365.09999999999997, 534.3000000000001 366.7, C 534.0000000000001 367.5, 533.8000000000001 368.3, 533.8000000000001 369.2, C 533.8000000000001 370.5, 533.9000000000001 371.59999999999997, 534.3000000000001 372.7, C 534.9000000000001 375.4, 536.4000000000001 377.9, 539.1 379.4, C 544.3000000000001 382.4, 551.1 380, 552.9 374.2, C 553.1999999999999 373.2, 553.3 372.09999999999997, 553.3 371, C 553.4 370.1, 553.4 369.2, 553.2 368.3 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightPupil: [
      {
        start: 0,
        time: 200,
        d: 'M719 381.71661845813804, C 719.5 381.34727785021903, 719.8 380.91078440449667, 719.8 380.50786737767595, C 719.9 378.9633521081966, 716.5 377.5867189332259, 712.0999999999999 377.2173783253069, C 710.1999999999999 377.0494962307983, 708.3999999999999 377.11664906860176, 706.8 377.35168400091385, C 704 377.5531425143241, 701.5 378.22467089235863, 700.1999999999999 379.13123420270523, C 698.1999999999999 380.5414437965776, 699.1999999999999 382.18668832276217, 702.5999999999999 383.2611337276174, C 706.0999999999999 384.36915555137426, 711.8999999999999 384.6713433214898, 715.6999999999999 383.5297450788311, C 716.4999999999999 383.29471014651904, 717.0999999999999 383.02609879530524, 717.5999999999999 382.72391102518975, C 717.6999999999999 382.6567581873863, 717.8999999999999 382.5896053495829, 717.9999999999999 382.5560289306811, C 718.4 382.25384116056557, 718.7 381.98522980935184, 719 381.71661845813804 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 2200,
        time: 200,
        d: 'M719 376.7, C 719.5 375.59999999999997, 719.8 374.3, 719.8 373.09999999999997, C 719.9 368.49999999999994, 716.5 364.4, 712.0999999999999 363.29999999999995, C 710.1999999999999 362.79999999999995, 708.3999999999999 362.99999999999994, 706.8 363.69999999999993, C 704 364.29999999999995, 701.5 366.29999999999995, 700.1999999999999 368.99999999999994, C 698.1999999999999 373.19999999999993, 699.1999999999999 378.09999999999997, 702.5999999999999 381.29999999999995, C 706.0999999999999 384.59999999999997, 711.8999999999999 385.49999999999994, 715.6999999999999 382.09999999999997, C 716.4999999999999 381.4, 717.0999999999999 380.59999999999997, 717.5999999999999 379.7, C 717.6999999999999 379.5, 717.8999999999999 379.3, 717.9999999999999 379.2, C 718.4 378.3, 718.7 377.5, 719 376.7 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    eyelids: [
      {
        start: 0,
        time: 200,
        attr: { opacity: 1 },
      },
      {
        start: 2200,
        time: 200,
        attr: { opacity: 0 },
      },
    ],
    lipsClosed: [
      {
        start: 0,
        time: 200,
        d: 'M558.6 429.9 C 561.2 435.29999999999995, 564.9 440.09999999999997, 569.5 443.9 C 570.9 445.09999999999997, 572.4 446.2, 574.2 446.79999999999995 C 577.9000000000001 448.09999999999997, 582.1 446.99999999999994, 585.9000000000001 446.09999999999997 C 594.9000000000001 443.9, 604.6000000000001 442.7, 613.2 445.99999999999994 C 616.2 447.19999999999993, 619.1 448.8999999999999, 622.2 449.79999999999995 C 629.4000000000001 452.09999999999997, 637.5 450.29999999999995, 644.1 446.49999999999994 C 650.7 442.69999999999993, 655.9 436.99999999999994, 660.8000000000001 431.09999999999997 Z',
        attr: { 'stroke-opacity': 0 },
      },
      {
        start: 2000,
        time: 200,
        d: 'M558.6 441.0873888101382 C 561.2 443.5996144060143, 564.9 445.832703824571, 569.5 447.6005662809283 C 570.9 448.1588386355675, 572.4 448.6705882939867, 574.2 448.9497244713063 C 577.9000000000001 449.5545195221654, 582.1 449.0427698637462, 585.9000000000001 448.6240655977668 C 594.9000000000001 447.6005662809283, 604.6000000000001 447.0422939262892, 613.2 448.57754290154685 C 616.2 449.135815256186, 619.1 449.92670109192477, 622.2 450.34540535790416 C 629.4000000000001 451.4154273709625, 637.5 450.5780188390038, 644.1 448.8101563826464 C 650.7 447.0422939262891, 655.9 444.39050024175316, 660.8000000000001 441.6456611647773 Z',
        attr: { 'stroke-opacity': 1 },
      },
    ],
    mouthOpen: [
      {
        start: 0,
        time: 200,
        attr: { opacity: 1 },
      },
      {
        start: 2000,
        time: 200,
        attr: { opacity: 0 },
      },
    ],
    leftArm: [
      {
        start: 200,
        time: 100,
        d: 'M441.3 486.5 C 434.3 399, 346.9 561.7, 338.1 583.9 C 313 635.1, 292.6 693.4, 308.6 749.7 C 313 765.3000000000001, 319.1 770.6, 330 771.5 C 347.9 773, 353.3 760.6, 353 746.6 C 350.8 687, 368.2 628.1, 403.8 579.4000000000001 C 429.2 552.4, 443.4 527.4, 441.3 486.5 Z',
      }, {
        start: 300,
        time: 100,
        d: 'M441.23674512765984 481.4029270151007 C 432.06940496222 411.29577559048806, 317.6086148965842 541.6550160108823, 306.0839586886026 559.4422018580409 C 273.2124960953822 600.4649007487857, 246.49624761324304 647.1762942122706, 267.4501679913914 692.2852385003357 C 273.2124960953822 704.7843420686095, 286.42339374238645 711.3634208710613, 300.698252 712.084523 C 324.1404504230537 713.286359881565, 316.4485700070903 683.6283002279376, 316.055684 672.411156 C 313.1745199480046 624.658170572492, 345.5035213999942 594.8563286348167, 392.1259942413745 555.8366912133466 C 425.39034284168514 534.2036273451804, 443.9869471772918 514.173012652434, 441.23674512765984 481.4029270151007 Z',
      }, {
        start: 400,
        time: 100,
        d: 'M441.17349025531973 476.30585403020143 C 429.83880992443994 423.5915511809761, 288.3172297931684 521.6100320217645, 274.06791737720516 534.9844037160818 C 233.42499219076447 565.8298014975715, 216.34684924370322 615.4571194238698, 232.442997 638.283529 C 239.56765320798164 647.6817361365474, 253.6863404847728 660.7912147421227, 271.336057 661.333419 C 300.32045384610734 662.2370927631301, 288.17153601418073 626.4409844558755, 287.685764 618.006696 C 284.1234358960093 582.1007251449843, 322.8070427999885 561.6126572696332, 380.45198848274896 532.2733824266932 C 421.58068568337023 516.0072546903607, 444.5738943545837 500.94602530486793, 441.17349025531973 476.30585403020143 Z',
      }, {
        start: 500,
        time: 100,
        d: 'M441.11023538297957 471.20878104530215 C 427.60821488665994 435.88732677146425, 259.02584468975266 501.5650480326466, 242.05187606580768 510.52660557412275 C 193.63748828614672 531.1947022463571, 131.74874686555478 547.8657131358045, 135.633492 579.584885 C 138.39807831197245 592.4220777048209, 171.01540522715928 594.7538006131839, 192.03998 595.117107 C 207.0146002691609 595.7226176446951, 238.14787902127114 577.2399906838132, 253.35138 565.687635 C 277.4379698440139 551.4742087174765, 310.5767024758593 534.6624562644101, 379.244121 515.003544 C 428.23716680093196 504.10435239550134, 451.9863665318755 510.3285909573019, 441.11023538297957 471.20878104530215 Z',
      }, {
        start: 600,
        time: 100,
        d: 'M441.11023538297957 471.20878104530215 C 427.60821488665994 435.88732677146425, 259.02584468975266 501.5650480326466, 242.05187606580768 510.52660557412275 C 186.28012028614674 539.3695562463571, 158.11264919888808 515.0981767191379, 134.816007 555.877811 C 124.16020881197247 592.6945735381544, 170.19792022715924 593.1188296131838, 191.222495 593.482136 C 207.8264465191609 594.087646644695, 240.9164348647928 577.6246380867553, 254.804755926855 566.5640259862755 C 276.5305056042022 551.5301388704186, 309.7045242862029 534.1380004010801, 378.3719428103436 514.47908813667 C 427.3649886112756 503.57989653217135, 451.4175727818755 508.44446154063525, 441.11023538297957 471.20878104530215 Z',
      }, {
        start: 700,
        time: 100,
        d: 'M441.11023538297957 471.20878104530215 C 427.60821488665994 435.88732677146425, 259.02584468975266 501.5650480326466, 242.05187606580768 510.52660557412275 C 186.94897192251037 538.6263877009026, 147.46675998676687 490.57980948428946, 129.093609 529.71828 C 120.17806376651788 563.7605469169423, 173.39843063547693 592.4618902983866, 194.4230054083177 592.8251966852027 C 212.65628817747861 593.4307073298978, 243.68499070831444 578.0092854896975, 256.25813185371 567.440416972551 C 275.6230413643905 551.5860690233607, 308.83234609654653 533.6135445377502, 377.49976462068724 513.95463227334 C 426.4928104216192 503.0554406688413, 450.8487790318755 506.5603321239686, 441.11023538297957 471.20878104530215 Z',
      }, {
        start: 800,
        time: 100,
        d: 'M441.11023538297957 471.20878104530215 C 427.60821488665994 435.88732677146425, 259.02584468975266 501.5650480326466, 242.05187606580768 510.52660557412275 C 187.617823558874 537.883219155448, 148.2656667746457 524.1029012494408, 134.816007 561.600208 C 127.64071472106338 592.8679792957302, 162.02306622715923 593.1188296131838, 183.047641 593.482136 C 202.91025501916093 594.087646644695, 246.4535465518361 578.3939328926397, 257.71150778056494 568.3168079588265 C 274.7155771245788 551.6419991763028, 307.96016790689015 533.0890886744202, 376.62758643103086 513.4301764100101 C 425.6206322319628 502.53098480551125, 450.2799852818755 504.6762027073019, 441.11023538297957 471.20878104530215 Z',
      }, {
        start: 900,
        time: 100,
        d: 'M441.11023538297957 471.20878104530215 C 427.60821488665994 435.88732677146425, 259.02584468975266 501.5650480326466, 242.05187606580768 510.52660557412275 C 188.28667519523762 537.1400506099935, 154.78696956252446 549.4511400145923, 146.260801 585.307283 C 140.82576167560882 613.800558674518, 153.84821322715925 616.8259046131839, 174.872788 617.189211 C 196.36473326916098 617.7947216446951, 221.33649368793786 576.0905023504798, 249.263953 563.235179 C 268.8120931773471 553.9147633841427, 307.08798971723377 532.5646328110902, 375.7554082413745 512.9057205466801 C 424.74845404230643 502.00652894218126, 449.7111915318755 502.79207329063524, 441.11023538297957 471.20878104530215 Z',
      }, {
        start: 1000,
        time: 100,
        d: 'M441.11023538297957 471.20878104530215 C 427.60821488665994 435.88732677146425, 259.02584468975266 501.5650480326466, 242.05187606580768 510.52660557412275 C 188.95552683160125 536.396882064539, 142.50611035040328 531.4726557797438, 138.903433 565.687635 C 135.20864663015428 591.406415053306, 157.93564022715924 597.2062566131838, 178.960215 597.569563 C 202.08149151916098 598.175073644695, 227.590750619887 576.8111594965596, 251.95494526528248 564.8563224794132 C 268.5291314009629 553.6935892802226, 306.2158115275774 532.0401769477602, 374.8832300517181 512.3812646833501 C 423.87627585265005 501.4820730788513, 449.1423977818755 500.9079438739686, 441.11023538297957 471.20878104530215 Z',
      }, {
        start: 1700,
        time: 100,
        d: 'M441.11023538297957 471.20878104530215 C 427.60821488665994 435.88732677146425, 259.02584468975266 501.5650480326466, 242.05187606580768 510.52660557412275 C 188.95552683160125 536.396882064539, 142.50611035040328 531.4726557797438, 138.903433 565.687635 C 135.20864663015428 591.406415053306, 157.93564022715924 597.2062566131838, 178.960215 597.569563 C 202.08149151916098 598.175073644695, 227.590750619887 576.8111594965596, 251.95494526528248 564.8563224794132 C 268.5291314009629 553.6935892802226, 306.2158115275774 532.0401769477602, 374.8832300517181 512.3812646833501 C 423.87627585265005 501.4820730788513, 449.1423977818755 500.9079438739686, 441.11023538297957 471.20878104530215 Z',
      }, {
        start: 1800,
        time: 100,
        d: 'M441.1576765372347 475.0315857839766 C 429.28116116499496 426.66549507859816, 311.65008351731444 488.4977270244849, 266.06390704935575 528.869954180592 C 202.08415312370096 582.7871155484044, 188.23843801280248 534.8415535848079, 163.990014 578.40975 C 154.65499922261571 601.5988350399795, 186.37084992036944 618.7865372098878, 204.864281 619.284017 C 226.68023838937074 620.1131499835212, 250.53217701595338 603.6490867628598, 268.730323 591.182959 C 290.82952860176033 576.852155100607, 325.84327610689445 540.1855721983075, 386.24384 513.266388 C 429.338624350699 498.3419942966258, 447.7067983364066 507.53095790547644, 441.1576765372347 475.0315857839766 Z',
      }, {
        start: 1900,
        time: 100,
        d: 'M441.2051176914898 478.85439052265104 C 430.95410744333 417.4436633857321, 319.93693264530583 536.4310068959286, 286.612815 570.745825 C 235.5929790495635 623.7572659118748, 223.0256253418683 587.6943690565386, 212.19334266666667 635.5065000000001 C 207.43666614841047 656.165890026653, 230.61389994691297 669.3910248065919, 246.57618733333334 670.0226779999999 C 267.08682559291384 671.0754333223475, 284.78811801063557 655.9660578419066, 296.82021533333335 642.9886393333334 C 310.8196857345069 613.5681034004047, 339.962184071263 569.4903814655383, 392.0958933333333 535.3109253333333 C 429.2924162337993 516.3613295310838, 446.27119889093774 514.1539719369842, 441.2051176914898 478.85439052265104 Z',
      }, {
        start: 2000,
        time: 100,
        d: 'M441.3 486.5 C 434.3 399, 346.9 561.7, 338.1 583.9 C 313 635.1, 292.6 693.4, 308.6 749.7 C 313 765.3000000000001, 319.1 770.6, 330 771.5 C 347.9 773, 353.3 760.6, 353 746.6 C 350.8 687, 368.2 628.1, 403.8 579.4000000000001 C 429.2 552.4, 443.4 527.4, 441.3 486.5 Z',
      },
    ],
    rightArm: [
      {
        start: 200,
        time: 100,
        d: 'M827.6 567.9 C 855.9 633.5, 878.8000000000001 702.5999999999999, 891.5 773.0999999999999 C 893.5 783.4999999999999, 894.1 796.5999999999999, 902.8 803.8999999999999 C 942.5999999999999 825.3999999999999, 931.5 750.8999999999999, 932.0999999999999 729.7999999999998 C 927.6999999999999 628.4999999999999, 885.3999999999999 532.1999999999998, 820.0999999999999 455.09999999999985 Z',
      }, {
        start: 300,
        time: 100,
        d: 'M831.5117438627942 544.7498539009574 C 908.0110273717372 596.8866483681808, 933.9378272994688 620.5954255646006, 928.7398015737997 707.8362902526989 C 929.6054192705451 722.6344216194539, 935.0255001191587 734.6749000841048, 947.018829 733.0109450049999 C 983.0023487652264 726.7679544843493, 990.8467285087015 698.9024920275104, 990.5153750177255 673.422826831498 C 983.8204852848863 592.9128073264715, 919.4582498987273 516.3766288631542, 820.0999999999999 455.0999999999999 Z',
        move: { x: -6.30800499999998, y: -4.999947122996673e-9 },
      }, {
        start: 400,
        time: 100,
        d: 'M835.4234877255885 521.5997078019147 C 909.9635997434743 560.2732967363615, 981.9419735989377 573.2541051292012, 965.9796031475994 642.5725805053978 C 962.6584305410902 662.1771272389078, 974.2197122383172 666.2643246632095, 991.3728110000001 666.8350590050001 C 1023.9481340304528 673.1914134636986, 1055.4140254819522 648.6335433970247, 1055.5317060000002 616.771678005 C 1046.5419265343216 557.0516389949468, 953.5164997974548 500.55325772630863, 820.0999999999999 455.09999999999997 Z',
        move: { x: -11.03900800000008, y: 4.699999994999985 },
      }, {
        start: 500,
        time: 100,
        d: 'M839.3352315883827 498.4495617028722 C 911.9161721152115 523.6599451045423, 969.1164181770074 550.960091900705, 1001.6880770000001 578.0535679649998 C 1012.1640460902362 585.9387550652649, 1027.008327357476 586.913398202314, 1049.3211960000003 589.7188219649998 C 1102.3048822956798 596.5232144030476, 1106.1086464729278 572.066880553037, 1107.647465 563.9580529649999 C 1096.3627958014822 525.02799444992, 987.5747496961822 484.7298865894631, 820.0999999999999 455.1 Z',
        move: { x: -18.924013000000173, y: 8.908401035000054 },
      }, {
        start: 600,
        time: 100,
        d: 'M839.3352315883827 498.4495617028722 C 916.7766951152114 551.3649221045424, 979.9371788204572 569.8540718001295, 1001.81568764345 577.9915098644246 C 1018.1647879003528 581.664244048023, 1025.5816016059118 586.8656174726375, 1047.8944702484362 589.6710412353233 C 1104.9690962107823 596.5969467567044, 1140.6183544729283 566.720306553037, 1112.9940390000002 539.169388965 C 1089.0720118014824 518.2232624499202, 1000.2121076961821 526.5303795894631, 820.0999999999999 455.1 Z',
        move: { x: 0, y: 0 },
      }, {
        start: 700,
        time: 100,
        d: 'M839.3352315883827 498.4495617028722 C 916.3348293879387 548.8462878318152, 979.0926849184526 568.0687375177362, 1001.9432982868999 577.9294517638493 C 1017.2724253468331 581.6316435762355, 1024.1548758543477 586.8178367429609, 1046.467744496872 589.6232605056467 C 1107.6333101258847 596.6706791103611, 1155.4650414729285 546.968911825764, 1130.4919200000004 521.185456965 C 1100.9140115287553 492.77180054082913, 1056.4174209689095 560.6424087712813, 820.0999999999999 455.1 Z',
        move: { x: 0, y: 0 },
      }, {
        start: 800,
        time: 100,
        d: 'M839.3352315883827 498.4495617028722 C 915.892963660666 546.3276535590879, 966.7723610860984 567.6827695370687, 990.5950790000002 579.2667599649999 C 1004.9042328629637 582.998409406174, 1022.9256743574758 595.7107382023141, 1045.2385430000002 598.5161619649999 C 1082.5523682956793 606.9269906530475, 1152.630408472928 598.9361130984914, 1130.3084809999998 574.920120965 C 1102.5598964560274 545.4548243317383, 1049.5331538416367 553.0511565530995, 820.0999999999999 455.1 Z',
        move: { x: 0, y: 0 },
      }, {
        start: 900,
        time: 100,
        d: 'M839.3352315883827 498.4495617028722 C 915.892963660666 546.3276535590879, 983.1067570860984 566.9582495370689, 1007.4168680000001 574.643094965 C 1050.5637538629635 590.7069854061745, 1037.920007357476 595.7924882023141, 1062.810326 607.8791699649998 C 1077.242714517901 615.3576080974918, 1109.1232094729285 599.9698140984914, 1102.2781650000002 560.1023119649998 C 1095.020879456028 526.911324331738, 1049.5331538416367 553.0511565530995, 820.0999999999999 455.1 Z',
        move: { x: 0, y: 0 },
      }, {
        start: 1000,
        time: 100,
        d: 'M839.3352315883827 498.4495617028722 C 915.892963660666 546.3276535590879, 976.8784300860984 570.9871805370688, 1001.1885410000002 578.6720259649999 C 1036.0805608629632 589.243692406174, 1039.602693357476 588.5496492023143, 1062.4751279999998 593.141332965 C 1076.040322517901 595.1275470974921, 1127.1203294729285 592.5398180984915, 1115.6629790000002 552.6723159649999 C 1100.622425456028 516.8869053317381, 1049.5331538416367 553.0511565530995, 820.0999999999999 455.1 Z',
        move: { x: 0, y: 0 },
      }, {
        start: 1700,
        time: 100,
        d: 'M839.3352315883827 498.4495617028722 C 915.892963660666 546.3276535590879, 976.8784300860984 570.9871805370688, 1001.1885410000002 578.6720259649999 C 1036.0805608629632 589.243692406174, 1039.602693357476 588.5496492023143, 1062.4751279999998 593.141332965 C 1076.040322517901 595.1275470974921, 1127.1203294729285 592.5398180984915, 1115.6629790000002 552.6723159649999 C 1100.622425456028 516.8869053317381, 1049.5331538416367 553.0511565530995, 820.0999999999999 455.1 Z',
        move: { x: 18.924013000000173, y: -8.908401035000054 },
      }, {
        start: 1800,
        time: 100,
        d: 'M836.401423691287 515.8121712771541 C 900.8947227454995 568.1207401693159, 956.788508262336 613.9720154265071, 974.4281816977623 626.6755452474555 C 989.062413094985 635.476648328336, 990.5711125770877 639.2275420099633, 1009.4807640589809 643.1566098319776 C 1043.0984270307404 650.0198905980134, 1096.756306854696 614.4885060738686, 1080.1648612499998 591.20151197375 C 1058.2534228420207 543.7775394988038, 1006.0696043812274 626.5788294148246, 820.0999999999999 455.09999999999997 Z',
        move: { x: 11.03900800000008, y: -4.699999994999985 },
      }, {
        start: 1900,
        time: 100,
        d: 'M833.4676157941914 533.174780851436 C 885.896481830333 589.9138267795439, 932.4882528763823 634.6257856018678, 945.0790034999999 647.6387684825 C 955.5018244314816 656.972837203087, 970.400957178738 668.8328776011572, 985.9073915000001 673.8855894825 C 1021.5858334811732 685.6277766598572, 1034.380088236464 657.0426900492456, 1030.8099074999998 637.4010079825 C 1014.7356152280138 572.0183596658692, 981.4000739208183 657.3339066098829, 820.0999999999999 455.0999999999999 Z',
        move: { x: 6.30800499999998, y: 4.999947122996673e-9 }
      }, {
        start: 2000,
        time: 100,
        d: 'M827.6 567.9 C 855.9 633.5, 878.8000000000001 702.5999999999999, 891.5 773.0999999999999 C 893.5 783.4999999999999, 894.1 796.5999999999999, 902.8 803.8999999999999 C 942.5999999999999 825.3999999999999, 931.5 750.8999999999999, 932.0999999999999 729.7999999999998 C 927.6999999999999 628.4999999999999, 885.3999999999999 532.1999999999998, 820.0999999999999 455.09999999999985 Z',
        move: { x: 0, y: 0 },
      },
    ],
  };

  _.forEach(animations, (times, id) => createAnimationForElement(blobEl, timeline, times, id));

  return 2600;
};

/** Blinks, looks left, blinks, reset to right */
export const blinkLeftRight: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const animations: {[key: string]: BlobAnimationStep[]} = {
    leftEyeWhite: [
      {
        start: 0,
        time: 200,
        d: 'M559.3 388.08518021935475, C 543.1999999999999 379.93497391523056, 463.19999999999993 385.8942645462031, 492.79999999999995 395.56934815884085, C 517.7 401.6863847182804, 584.4 398.2159742920081, 559.3 388.08518021935475 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M559.3 351.5, C 543.1999999999999 305, 463.19999999999993 339, 492.79999999999995 394.2, C 517.7 429.1, 584.4 409.3, 559.3 351.5 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1700,
        time: 200,
        d: 'M559.3 382.4463081656343, C 543.1999999999999 371.57865073090437, 463.19999999999993 379.52489487672847, 492.79999999999995 392.42585596053686, C 517.7 400.582441863162, 584.4 395.9549232135351, 559.3 382.4463081656343 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1900,
        time: 200,
        d: 'M559.3 351.5, C 543.1999999999999 305, 463.19999999999993 339, 492.79999999999995 394.2, C 517.7 429.1, 584.4 409.3, 559.3 351.5 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightEyeWhite: [
      {
        start: 0,
        time: 200,
        d: 'M735.9 401.00355865164977, C 759.3 393.0128371098105, 703.3 379.7881929580664, 662.8 391.4146928014427, C 633.9 401.00355865164977, 702.1 410.49254048258405, 735.9 401.00355865164977 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M735.9 403.8, C 759.3 363.8, 703.3 297.6, 662.8 355.8, C 633.9 403.8, 702.1 451.3, 735.9 403.8 Z',
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 1700,
        time: 200,
        d: 'M735.9 394.71380184302365, C 759.3 386.80965891840793, 703.3 373.72830237816896, 662.8 385.22883033348467, C 633.9 394.71380184302365, 702.1 404.09997156600474, 735.9 394.71380184302365 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1900,
        time: 200,
        d: 'M735.9 403.8, C 759.3 363.8, 703.3 297.6, 662.8 355.8, C 633.9 403.8, 702.1 451.3, 735.9 403.8 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    leftIris: [
      {
        start: 0,
        time: 200,
        d: 'M571.3 389.27860890600294, C 567.8 379.411112148889, 499.09999999999997 383.84711954058264, 509.19999999999993 392.2126610390918, C 523.5 399.0413180869352, 577.9 397.347252271997, 571.3 389.27860890600294 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M571.3 366.8, C 567.8 310.3, 499.09999999999997 335.7, 509.19999999999993 383.6, C 523.5 422.7, 577.9 413, 571.3 366.8 Z',
        attr: { 'fill-opacity': 1 },
        move: { x: -28.26992215499979, y: -50 },
      },
      {
        start: 1700,
        time: 200,
        d: 'M571.3 386.4226146550823, C 567.8 371.97176398935505, 499.09999999999997 378.46825260722176, 509.19999999999993 390.71950476453765, C 523.5 400.7200049597578, 577.9 398.23906245608424, 571.3 386.4226146550823 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1900,
        time: 200,
        d: 'M571.3 366.8, C 567.8 310.3, 499.09999999999997 335.7, 509.19999999999993 383.6, C 523.5 422.7, 577.9 413, 571.3 366.8 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightIris: [
      {
        start: 0,
        time: 200,
        d: 'M743.2 394.3360239081912, C 752.1 385.5251001669388, 678.7 383.57962247954555, 673.2 393.355245900497, C 671.9 399.4810888665867, 736.8 400.7834334341806, 743.2 394.3360239081912 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M743.2 387.2, C 752.1 332.4, 678.7 320.29999999999995, 673.2 381.09999999999997, C 671.9 419.2, 736.8 427.3, 743.2 387.2 Z',
        attr: { 'fill-opacity': 1 },
        move: { x: -19.84056253999995, y: -50 },
      },
      {
        start: 1700,
        time: 200,
        d: 'M743.2 392.1127660326336, C 752.1 378.70692404126703, 678.7 375.74687498842866, 673.2 390.62050989855817, C 671.9 399.9409949327017, 736.8 401.9225153730315, 743.2 392.1127660326336 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1900,
        time: 200,
        d: 'M743.2 387.2, C 752.1 332.4, 678.7 320.29999999999995, 673.2 381.09999999999997, C 671.9 419.2, 736.8 427.3, 743.2 387.2 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    leftPupil: [
      {
        start: 0,
        time: 200,
        d: 'M553.2 375.3349069518154, C 552.9000000000001 374.16712602631196, 551.7 372.9993451008087, 549.7 372.2640756291953, C 545.6 370.6637832498017, 539.9000000000001 371.00979241291384, 536.7 372.6965870830855, C 535.5 373.2588519731427, 534.7 373.9508702993669, 534.3000000000001 374.6428886255912, C 534.0000000000001 374.98889778870335, 533.8000000000001 375.3349069518154, 533.8000000000001 375.7241672603166, C 533.8000000000001 376.28643215037374, 533.9000000000001 376.7621947496529, 534.3000000000001 377.23795734893207, C 534.9000000000001 378.4057382744355, 536.4000000000001 379.48701690916084, 539.1 380.1357840899962, C 544.3000000000001 381.43331845166665, 551.1 380.3952909623303, 552.9 377.8867245297673, C 553.1999999999999 377.4542130758772, 553.3 376.9784504765979, 553.3 376.50268787731886, C 553.4 376.1134275688177, 553.4 375.7241672603166, 553.2 375.3349069518154 Z',
        attr: { 'fill-opacity': 0 },

      },
      {
        start: 200,
        time: 200,
        d: 'M553.2 368.3, C 552.9000000000001 365.6, 551.7 362.90000000000003, 549.7 361.2, C 545.6 357.5, 539.9000000000001 358.3, 536.7 362.2, C 535.5 363.5, 534.7 365.09999999999997, 534.3000000000001 366.7, C 534.0000000000001 367.5, 533.8000000000001 368.3, 533.8000000000001 369.2, C 533.8000000000001 370.5, 533.9000000000001 371.59999999999997, 534.3000000000001 372.7, C 534.9000000000001 375.4, 536.4000000000001 377.9, 539.1 379.4, C 544.3000000000001 382.4, 551.1 380, 552.9 374.2, C 553.1999999999999 373.2, 553.3 372.09999999999997, 553.3 371, C 553.4 370.1, 553.4 369.2, 553.2 368.3 Z',
        attr: { 'fill-opacity': 1 },
        move: { x: -32.68407047999983, y: -15 },
      },
      {
        start: 1700,
        time: 200,
        d: 'M553.2 376.69816745985474, C 552.9000000000001 375.8273078395274, 551.7 374.9564482192001, 549.7 374.40812919899406, C 545.6 373.2147289785455, 539.9000000000001 373.4727614586425, 536.7 374.7306697991153, C 535.5 375.14997257927286, 534.7 375.6660375394668, 534.3000000000001 376.18210249966074, C 534.0000000000001 376.4401349797578, 533.8000000000001 376.69816745985474, 533.8000000000001 376.98845399996384, C 533.8000000000001 377.40775678012136, 533.9000000000001 377.76255144025475, 534.3000000000001 378.1173461003881, C 534.9000000000001 378.98820572071537, 536.4000000000001 379.7945572210184, 539.1 380.27836812120023, C 544.3000000000001 381.245989921564, 551.1 380.471892481273, 552.9 378.6011570005699, C 553.1999999999999 378.2786164004487, 553.3 377.9238217403153, 553.3 377.569027080182, C 553.4 377.27874054007293, 553.4 376.98845399996384, 553.2 376.69816745985474 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1900,
        time: 200,
        d: 'M553.2 368.3, C 552.9000000000001 365.6, 551.7 362.90000000000003, 549.7 361.2, C 545.6 357.5, 539.9000000000001 358.3, 536.7 362.2, C 535.5 363.5, 534.7 365.09999999999997, 534.3000000000001 366.7, C 534.0000000000001 367.5, 533.8000000000001 368.3, 533.8000000000001 369.2, C 533.8000000000001 370.5, 533.9000000000001 371.59999999999997, 534.3000000000001 372.7, C 534.9000000000001 375.4, 536.4000000000001 377.9, 539.1 379.4, C 544.3000000000001 382.4, 551.1 380, 552.9 374.2, C 553.1999999999999 373.2, 553.3 372.09999999999997, 553.3 371, C 553.4 370.1, 553.4 369.2, 553.2 368.3 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    rightPupil: [
      {
        start: 0,
        time: 200,
        d: 'M719 381.71661845813804, C 719.5 381.34727785021903, 719.8 380.91078440449667, 719.8 380.50786737767595, C 719.9 378.9633521081966, 716.5 377.5867189332259, 712.0999999999999 377.2173783253069, C 710.1999999999999 377.0494962307983, 708.3999999999999 377.11664906860176, 706.8 377.35168400091385, C 704 377.5531425143241, 701.5 378.22467089235863, 700.1999999999999 379.13123420270523, C 698.1999999999999 380.5414437965776, 699.1999999999999 382.18668832276217, 702.5999999999999 383.2611337276174, C 706.0999999999999 384.36915555137426, 711.8999999999999 384.6713433214898, 715.6999999999999 383.5297450788311, C 716.4999999999999 383.29471014651904, 717.0999999999999 383.02609879530524, 717.5999999999999 382.72391102518975, C 717.6999999999999 382.6567581873863, 717.8999999999999 382.5896053495829, 717.9999999999999 382.5560289306811, C 718.4 382.25384116056557, 718.7 381.98522980935184, 719 381.71661845813804 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 200,
        time: 200,
        d: 'M719 376.7, C 719.5 375.59999999999997, 719.8 374.3, 719.8 373.09999999999997, C 719.9 368.49999999999994, 716.5 364.4, 712.0999999999999 363.29999999999995, C 710.1999999999999 362.79999999999995, 708.3999999999999 362.99999999999994, 706.8 363.69999999999993, C 704 364.29999999999995, 701.5 366.29999999999995, 700.1999999999999 368.99999999999994, C 698.1999999999999 373.19999999999993, 699.1999999999999 378.09999999999997, 702.5999999999999 381.29999999999995, C 706.0999999999999 384.59999999999997, 711.8999999999999 385.49999999999994, 715.6999999999999 382.09999999999997, C 716.4999999999999 381.4, 717.0999999999999 380.59999999999997, 717.5999999999999 379.7, C 717.6999999999999 379.5, 717.8999999999999 379.3, 717.9999999999999 379.2, C 718.4 378.3, 718.7 377.5, 719 376.7 Z',
        attr: { 'fill-opacity': 1 },
        move: { x: -27.435234000000037, y: -15 },
      },
      {
        start: 1700,
        time: 200,
        d: 'M719 382.0862682210892, C 719.5 381.77076628424606, 719.8 381.39790035888603, 719.8 381.0537164277845, C 719.9 379.73434469189516, 716.5 378.5583829272981, 712.0999999999999 378.24288099045503, C 710.1999999999999 378.0994710191627, 708.3999999999999 378.15683500767966, 706.8 378.3576089674889, C 704 378.5297009330397, 701.5 379.10334081820895, 700.1999999999999 379.87775466318743, C 698.1999999999999 381.0823984220429, 699.1999999999999 382.48781614070765, 702.5999999999999 383.4056399569785, C 706.0999999999999 384.35214576750775, 711.8999999999999 384.610283715834, 715.6999999999999 383.63509591104616, C 716.4999999999999 383.4343219512369, 717.0999999999999 383.2048659971691, 717.5999999999999 382.94672804884306, C 717.6999999999999 382.8893640603261, 717.8999999999999 382.83200007180926, 717.9999999999999 382.8033180775508, C 718.4 382.54518012922455, 718.7 382.31572417515684, 719 382.0862682210892 Z',
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1900,
        time: 200,
        d: 'M719 376.7, C 719.5 375.59999999999997, 719.8 374.3, 719.8 373.09999999999997, C 719.9 368.49999999999994, 716.5 364.4, 712.0999999999999 363.29999999999995, C 710.1999999999999 362.79999999999995, 708.3999999999999 362.99999999999994, 706.8 363.69999999999993, C 704 364.29999999999995, 701.5 366.29999999999995, 700.1999999999999 368.99999999999994, C 698.1999999999999 373.19999999999993, 699.1999999999999 378.09999999999997, 702.5999999999999 381.29999999999995, C 706.0999999999999 384.59999999999997, 711.8999999999999 385.49999999999994, 715.6999999999999 382.09999999999997, C 716.4999999999999 381.4, 717.0999999999999 380.59999999999997, 717.5999999999999 379.7, C 717.6999999999999 379.5, 717.8999999999999 379.3, 717.9999999999999 379.2, C 718.4 378.3, 718.7 377.5, 719 376.7 Z',
        attr: { 'fill-opacity': 1 },
      },
    ],
    eyelids: [
      {
        start: 0,
        time: 100,
        attr: { opacity: 1 },
      },
      {
        start: 200,
        time: 100,
        attr: { opacity: 0 },
      },
      {
        start: 1700,
        time: 100,
        attr: { opacity: 1 },
      },
      {
        start: 2000,
        time: 100,
        attr: { opacity: 0 },
      },
    ],
  };

  _.forEach(animations, (times, id) => createAnimationForElement(blobEl, timeline, times, id));

  return 2400;
};

export const wiggle: BlobAnimation = (blobEl: Element, timeline: Timeline): number => {
  const animations: {[key: string]: BlobAnimationStep[]} = {
    bodyOutline1: [
      {
        start: 600,
        time: 100,
        d: 'M790.7, 224.6 C 799.1, 215.1, 782.4000000000001, 208.4, 776.9000000000001, 217.6 C 771.9, 227.5, 783.3, 234.6, 790.7, 224.6Z',
      },
      {
        start: 700,
        time: 100,
        d: 'M787.7275415108611, 224.6 C 791.5171647659852, 215.1, 783.9830328182979, 208.4, 781.5017318774428, 217.6 C 779.2460037493928, 227.5, 784.3890638813469, 234.6, 787.7275415108611, 224.6Z',
        move: { x: 1.9070070000000214, y: -76.91592100000003 },
      },
      {
        start: 900,
        time: 100,
        d: 'M790.7, 224.6 C 799.1, 215.1, 782.4000000000001, 208.4, 776.9000000000001, 217.6 C 771.9, 227.5, 783.3, 234.6, 790.7, 224.6Z',
        move: { x: 1.9070070000000214, y: -64.20254600000001 },
      },
      {
        start: 1000,
        time: 100,
        d: 'M790.7, 226.61001798513047 C 799.1, 221.06199201041483, 782.4000000000001, 217.14917369140485, 776.9000000000001, 222.5219988458663 C 771.9, 228.3036259142542, 783.3, 232.45004532693636, 790.7, 226.61001798513047Z',
        move: { x: -1.4117762500001163, y: 74.96548362000007 },
      },
      {
        start: 1200,
        time: 100,
        d: 'M787.7436352736538, 228.90305165327214 C 792.4077869350222, 218.62714206064078, 783.1350092273021, 211.37992161110074, 780.0811004014062, 221.33132879554375 C 777.3048196505918, 232.0399082657596, 783.6347397624486, 239.71979859288413, 787.7436352736538, 228.90305165327214Z',
        move: { x: 4.726860750000014, y: 43.019646829999914 },
      },
      {
        start: 1400,
        time: 100,
        d: 'M788.2198696094958, 224.6 C 792.7799630156679, 215.1, 783.7140630295877, 208.4, 780.7282875850701, 217.6 C 778.0139462718722, 227.5, 784.2026444659631, 234.6, 788.2198696094958, 224.6Z',
        move: { x: 0.27717874999996184, y: -79.0287561700001 },
      },
      {
        start: 1500,
        time: 100,
        d: 'M790.7, 226.60390904287124 C 799.1, 221.04387204073737, 782.4000000000001, 217.12258278660082, 776.9000000000001, 222.50703967287782 C 771.9, 228.30118349615418, 783.3, 232.45657957143317, 790.7, 226.60390904287124Z',
        move: { x: -1.0408030833333441, y: 15.408614316666629 },
      },
      {
        start: 1600,
        time: 100,
        d: 'M790.7, 224.6 C 799.1, 215.1, 782.4000000000001, 208.4, 776.9000000000001, 217.6 C 771.9, 227.5, 783.3, 234.6, 790.7, 224.6Z',
      },
    ],
    bodyOutline2: [
      {
        start: 600,
        time: 100,
        d: 'M827.9, 648.7 C 827.9, 645.5, 828.6, 625.7, 828.8, 615.1 C 829, 600.8000000000001, 829.5, 586.5, 830.3, 572.2 C 832.3, 536.5, 813, 364.70000000000005, 795.0999999999999, 316.30000000000007 C 815.8, 314.20000000000005, 820.0999999999999, 291.20000000000005, 803.4999999999999, 282.30000000000007 C 781.6999999999999, 273.9000000000001, 755.2999999999998, 267.9000000000001, 743.7999999999998, 244.70000000000007 C 749.9999999999999, 243.50000000000009, 757.8999999999999, 240.10000000000008, 761.6999999999998, 234.30000000000007 C 788.4999999999998, 189.00000000000006, 616.0999999999998, 204.80000000000007, 603.6999999999998, 208.00000000000006 C 574.3999999999999, 213.90000000000006, 544.8999999999999, 228.00000000000006, 519.7999999999998, 245.30000000000007 C 441.39999999999986, 290.9000000000001, 420.1999999999998, 365.20000000000005, 421.79999999999984, 466.20000000000005 C 421.6999999999998, 466.20000000000005, 415.79999999999984, 526.5, 417.09999999999985, 556.4000000000001 C 414.1999999999999, 597.3000000000001, 403.1999999999999, 625.6000000000001, 395.6999999999999, 658.3000000000001 C 388.2999999999999, 684.2, 405.89999999999986, 732.4000000000001, 439.09999999999985, 740.2 C 432.39999999999986, 783.5, 434.29999999999984, 852.2, 491.29999999999984, 838 C 517.1999999999998, 825.5, 511.79999999999984, 782.5, 514.9999999999999, 762.9 C 576.2999999999998, 773.3, 638.0999999999999, 784.9, 700.4999999999999, 782.4 C 703.4999999999999, 816.6, 698.6999999999999, 841.6, 708.0999999999999, 853.3 C 763.8, 894.3, 782.1999999999999, 811.4, 779.3999999999999, 774.8 C 867.6, 763.3, 823.9, 698.4, 827.9, 648.7Z',
      },
      {
        start: 700,
        time: 100,
        d: 'M827.9, 643.2807205582184 C 827.9, 640.000330378831, 828.6, 619.70291614387, 828.8, 608.8366236746484 C 829, 594.1773800605104, 829.5, 579.5181364463716, 830.3, 564.8588928322336 C 832.3, 528.2620398934401, 810.9198806100001, 338.8406224632375, 793.01988061, 289.224721 C 813.71988061, 287.0719649447767, 819.678388, 262.42537718642177, 803.078388, 253.301792 C 781.2783880000001, 244.69076777910763, 755.2999999999998, 252.91428921109247, 743.7999999999998, 229.13146041053218 C 749.9999999999999, 227.90131409326196, 755.8512000000001, 210.38518420013997, 759.6512, 204.439477 C 760.018875, 166.81222852304415, 616.0999999999998, 188.229095361293, 603.6999999999998, 191.50948554068052 C 574.3999999999999, 197.55770493392654, 544.8999999999999, 212.01192416185322, 519.7999999999998, 229.74653356916744 C 441.39999999999986, 276.4920936254411, 420.1999999999998, 352.658653103097, 421.79999999999984, 456.19596814001864 C 421.6999999999998, 456.19596814001864, 415.79999999999984, 518.010820582854, 417.09999999999985, 548.6619663215072 C 414.1999999999999, 590.5894533018048, 403.1999999999999, 619.6004039507643, 395.6999999999999, 653.1218910963811 C 388.2999999999999, 679.6725491107997, 405.89999999999986, 729.0834261878259, 439.09999999999985, 737.0793772500829 C 432.39999999999986, 781.4671568649215, 434.29999999999984, 851.8930335286495, 491.29999999999984, 837.3363021076173 C 517.1999999999998, 824.522277969384, 511.79999999999984, 780.4420349338633, 514.9999999999999, 760.3496450851139 C 576.2999999999998, 771.0109131681234, 638.0999999999999, 782.9023275684038, 700.4999999999999, 780.3395227407572 C 703.4999999999999, 815.3986927829624, 698.6999999999999, 841.026741059428, 708.0999999999999, 853.0206676528142 C 763.8, 895.050666826218, 782.1999999999999, 810.0680587414575, 779.3999999999999, 772.5485960647114 C 867.6, 760.7596938575373, 823.9, 694.2292805318323, 827.9, 643.2807205582184Z',
      },
      {
        start: 900,
        time: 100,
        d: 'M839.177348, 669.803056 C 839.177348, 666.838872415698, 828.6, 643.543108599371, 828.8, 633.7242504763697 C 829, 620.4780550840187, 820.1497595978839, 599.8030883923509, 820.9497595978838, 586.556893 C 822.9497595978838, 553.4877198876266, 805.7809936100001, 378.42780019923947, 793.01988061, 328.4556364866667 C 811.3169416100001, 311.2917800094682, 819.02396982, 291.0039945938408, 802.42396982, 282.759859 C 780.6239698200001, 274.97887709120636, 754.7, 304.250189986192, 743.2, 282.759859 C 749.4000000000001, 281.64829015588674, 760.83137, 228.29775158654803, 748.61178, 221.32320984 C 712.6376829999999, 193.07319697472008, 720.9177859999998, 229.05029552660363, 603.6999999999998, 256.6245201109059 C 574.3999999999999, 262.0897335944635, 544.8999999999999, 275.15066751279574, 519.7999999999998, 291.17578501543017 C 441.39999999999986, 333.41540109173866, 438.114063, 385.37823211545737, 427.233907, 485.54241749500005 C 426.39977999999996, 503.16145949500003, 415.79999999999984, 551.6534174859985, 417.09999999999985, 579.3500078518236 C 414.1999999999999, 617.235979288688, 396.344715, 639.5128049979107, 388.844715, 669.803056 C 381.44471500000003, 693.7944168854469, 402.410971, 743.0838735132631, 435.610971, 750.3090710000001 C 428.910971, 790.4181801250911, 434.29999999999984, 853.3517279257715, 491.29999999999984, 840.1981632704299 C 517.1999999999998, 828.6193211442487, 516.5999999999998, 791.702612453852, 519.7999999999998, 773.546988 C 581.0999999999998, 783.1805846489822, 630.9114698535328, 792.0588804252363, 693.3114698535328, 789.7431120000001 C 696.3114698535328, 821.4228240572313, 698.6999999999999, 843.5328698027697, 708.0999999999999, 854.3706660328753 C 763.8, 892.3492682067492, 793.5000000000001, 812.3790927454584, 790.7, 778.4762430000001 C 878.9000000000002, 767.8237082439134, 848.745476, 708.7334172936958, 839.177348, 669.803056Z',
      },
      {
        start: 1000,
        time: 100,
        d: 'M828.560664, 675.2549973882071 C 828.560664, 672.4489171014476, 829.260664, 655.0862953271214, 829.460664, 645.7911543772302 C 829.660664, 633.251483095773, 830.160664, 620.7118118143154, 830.960664, 608.1721405328582 C 832.960664, 576.8668073336946, 813.660664, 426.215371938283, 795.7606639999999, 383.7734076010426 C 838.7454049999999, 377.8388024128564, 825.943441, 372.12550502755033, 809.343441, 364.32109423 C 787.543441, 356.9551334772558, 765.813775, 349.9770030190079, 754.313775, 329.63292094 C 760.513775, 328.5806408324652, 775.74893937, 320.9238935197521, 785.00642637, 316.292664 C 850.9184193699999, 290.66759894055804, 717.2693929999998, 280.08676960925897, 604.3606639999998, 288.8051278960186 C 575.0606639999999, 293.9788384247319, 545.5606639999999, 306.34312968826697, 520.4606639999998, 321.5135012385615 C 442.06066399999986, 361.5001453248874, 420.8606639999998, 426.65382198308924, 422.46066399999984, 515.2207310339426 C 422.3606639999998, 515.2207310339426, 416.46066399999984, 568.0978064375707, 417.76066399999985, 594.3171191169819 C 414.8606639999999, 630.1823327821296, 403.8606639999999, 654.9986053181606, 396.3606639999999, 683.6732382484863 C 388.9606639999999, 706.3849505694474, 398.901526, 756.682782301023, 432.101526, 763.522603 C 425.401526, 801.4923768802172, 434.96066399999984, 853.7041656243323, 491.96066399999984, 841.2521843518363 C 517.8606639999998, 830.2909332316809, 521.507757, 805.7385557564033, 524.707757, 788.551314 C 586.007757, 797.6710749319686, 629.374405, 804.5093552240312, 691.774405, 802.317105 C 694.774405, 832.3070880647444, 699.3606639999999, 844.4090246744406, 708.7606639999999, 854.6687557229058 C 764.460664, 890.6216593970147, 789.6835070000001, 823.7744462798142, 786.883507, 791.679903 C 866.3234580000002, 782.2212699694572, 824.560664, 718.8369318419439, 828.560664, 675.2549973882071Z',
      },
      {
        start: 1100,
        time: 100,
        d: 'M827.9, 671.4614263327489 C 827.9, 668.5990718012408, 821.3332988706111, 650.601994385621, 821.533298870611, 641.120445 C 821.7332988706111, 628.3292981873224, 820.7332988706111, 603.9318308663965, 821.533298870611, 591.1406840537189 C 823.533298870611, 559.2075413115787, 813, 417.42746166138545, 795.0999999999999, 374.1343493723222 C 815.8, 372.2559292110198, 824.539925, 347.3580404974242, 807.939925, 339.3971169566668 C 786.1399250000001, 331.88343631145744, 755.2999999999998, 330.84123708325876, 743.7999999999998, 310.08916672982343 C 749.9999999999999, 309.01578378050783, 798.598012, 283.3306385883589, 776.9000000000001, 281.76773 C 740.3204820000001, 287.1689996633354, 701.6006379999998, 259.8458826650791, 603.6999999999998, 277.26153819658737 C 574.3999999999999, 282.5390043640559, 544.8999999999999, 295.1512540185146, 519.7999999999998, 310.6258582044813 C 441.39999999999986, 351.4144102784749, 436.474115, 403.0711513692686, 427.824386, 498.93330127 C 425.359063, 525.74028527, 415.79999999999984, 562.155262660775, 417.09999999999985, 588.9003878145559 C 414.1999999999999, 625.4848566703968, 403.1999999999999, 650.7988045584234, 395.6999999999999, 680.048489927274 C 388.2999999999999, 703.2156719166692, 406.59377556362494, 751.0214118294482, 439.79377556362493, 757.998401 C 433.09377556362494, 796.7296357544718, 434.29999999999984, 853.4892848208563, 491.29999999999984, 840.7875865872883 C 517.1999999999998, 829.6065141985837, 511.79999999999984, 791.1436251814407, 514.9999999999999, 773.6117036759522 C 576.2999999999998, 794.0123629033538, 638.9998379999998, 799.8892070800722, 700.4999999999999, 791.054176602331 C 703.4999999999999, 821.6455906578263, 698.6999999999999, 844.0077354352348, 708.0999999999999, 854.4732191910621 C 763.8, 891.1471366260126, 779.7000000000002, 823.7923565564575, 776.9000000000001, 791.054176602331 C 865.1000000000003, 780.7675900047229, 827.0537629999999, 699.3601151502376, 827.9, 671.4614263327489Z',
      },
      {
        start: 1200,
        time: 100,
        d: 'M827.9, 660.0807131663745 C 827.9, 657.0495359006204, 828.6, 638.2941265687664, 828.8, 628.2533518759558 C 829, 614.7077784696171, 829.5, 601.162205063278, 830.3, 587.6166316569393 C 832.3, 553.8000602858691, 813, 391.06373083069275, 795.0999999999999, 345.2171746861611 C 815.8, 343.2279646055099, 811.6999999999999, 315.29325600037873, 795.0999999999999, 306.86279423 C 773.3, 298.90595390739537, 760.605205, 305.06898417671766, 749.105205, 283.092949 C 753.031252, 273.31523552534225, 757.129761, 262.20910079417956, 760.929761, 256.715092 C 761.8066949999999, 221.53642983166776, 643.3397128249998, 209.1144327342459, 596.8304158249998, 238.523467 C 568.8947878249999, 252.75322208373433, 544.8999999999999, 261.57562700925735, 519.7999999999998, 277.96292910224065 C 441.39999999999986, 321.1572051392375, 420.1999999999998, 391.53735227846687, 421.79999999999984, 487.2088847288326 C 421.6999999999998, 487.2088847288326, 415.79999999999984, 544.3276313303875, 417.09999999999985, 572.650193907278 C 414.1999999999999, 611.3924283351985, 411.2067084695854, 643.6395123155748, 403.7067084695854, 674.614355 C 403.54858046958543, 708.3648729946977, 410.1969987818124, 728.5436669147241, 439.4468877818124, 749.0992005 C 432.7468877818124, 790.114817877236, 434.29999999999984, 852.8446424104282, 491.29999999999984, 839.3937932936442 C 517.1999999999998, 827.5532570992918, 511.79999999999984, 786.8218125907204, 514.9999999999999, 768.255851837976 C 576.2999999999998, 783.656181451677, 638.5499189999998, 792.3946035400361, 700.4999999999999, 786.7270883011655 C 703.4999999999999, 819.1227953289132, 698.6999999999999, 842.8038677176174, 708.0999999999999, 853.886609595531 C 763.8, 892.7235683130064, 780.95, 817.5961782782288, 778.15, 782.9270883011654 C 843.3076820000002, 765.4502760023614, 823.9, 707.1586850751188, 827.9, 660.0807131663745Z',
      },
      {
        start: 1300,
        time: 100,
        d: 'M825.886353, 663.882362 C 825.886353, 660.6823619999999, 821.9168381433384, 628.551299, 822.1168381433383, 617.951299 C 822.3168381433384, 603.651299, 821.3168381433384, 579.938237, 822.1168381433383, 565.638237 C 817.300614884085, 483.8168765860756, 822.2474470047689, 427.2720167890016, 795.0999999999999, 316.30000000000007 C 786.0215699999999, 277.804141, 819.416145, 253.60000000000002, 802.816145, 244.70000000000007 C 781.016145, 236.3000000000001, 755.2999999999998, 267.9000000000001, 743.7999999999998, 244.70000000000007 C 749.9999999999999, 243.50000000000009, 769.983417, 207.16092, 759.09353, 200.748841 C 732.6426899999999, 176.259514, 616.0999999999998, 204.80000000000007, 603.6999999999998, 208.00000000000006 C 574.3999999999999, 213.90000000000006, 544.8999999999999, 228.00000000000006, 519.7999999999998, 245.30000000000007 C 441.39999999999986, 290.9000000000001, 424.83115699999996, 349.34540535790416, 426.431157, 450.34540535790416 C 426.33115699999996, 485.15631535790413, 415.79999999999984, 526.5, 417.09999999999985, 556.4000000000001 C 414.1999999999999, 597.3000000000001, 403.1999999999999, 625.6000000000001, 395.6999999999999, 658.3000000000001 C 388.2999999999999, 684.2, 405.89999999999986, 732.4000000000001, 439.09999999999985, 740.2 C 447.3087859999999, 789.333872, 434.29999999999984, 852.2, 491.29999999999984, 838 C 517.1999999999998, 825.5, 507.9107509999999, 787.0374569999999, 514.9999999999999, 762.9 C 576.2999999999998, 773.3, 638.0999999999999, 784.9, 700.4999999999999, 782.4 C 709.3338719999998, 821.7856640000001, 698.6999999999999, 841.6, 708.0999999999999, 853.3 C 775.7982059999999, 878.7552269999999, 767.9394229999999, 819.826705, 779.3999999999999, 774.8 C 856.721591, 757.256439, 821.886353, 713.5823619999999, 825.886353, 663.882362Z',
      },
      {
        start: 1400,
        time: 100,
        d: 'M837.960977, 653.381048 C 837.960977, 650.1810479999999, 828.6, 625.7, 828.8, 615.1 C 829, 600.8000000000001, 829.5, 586.5, 830.3, 572.2 C 832.3, 536.5, 837.904396, 373.00146600000005, 795.0999999999999, 316.30000000000007 C 815.8, 314.20000000000005, 820.0999999999999, 291.20000000000005, 803.4999999999999, 282.30000000000007 C 781.6999999999999, 273.9000000000001, 755.2999999999998, 267.9000000000001, 743.7999999999998, 244.70000000000007 C 749.9999999999999, 243.50000000000009, 759.9394990000001, 229.78867000000002, 763.739499, 223.98867 C 770.281445, 188.661865, 616.0999999999998, 204.80000000000007, 603.6999999999998, 208.00000000000006 C 574.3999999999999, 213.90000000000006, 544.8999999999999, 228.00000000000006, 519.7999999999998, 245.30000000000007 C 427.16891599999985, 309.87477800000005, 407.1548399999998, 373.501465, 421.79999999999984, 466.20000000000005 C 421.6999999999998, 466.20000000000005, 415.79999999999984, 526.5, 417.09999999999985, 556.4000000000001 C 414.1999999999999, 597.3000000000001, 394.5123780712656, 620.681048, 387.0123780712656, 653.381048 C 379.6123780712656, 679.2810479999999, 405.89999999999986, 732.4000000000001, 439.09999999999985, 740.2 C 436.61244599999986, 801.554291, 434.29999999999984, 852.2, 491.29999999999984, 838 C 517.1999999999998, 825.5, 506.5103169999999, 796.0180780000001, 514.9999999999999, 762.9 C 576.2999999999998, 773.3, 638.0999999999999, 784.9, 700.4999999999999, 782.4 C 699.981236, 817.187742, 698.6999999999999, 841.6, 708.0999999999999, 853.3 C 780.158545, 882.9748539999999, 777.3660719999999, 817.9480329999999, 779.3999999999999, 774.8 C 867.6, 763.3, 850.6274209999999, 703.0810479999999, 837.960977, 653.381048Z',
      },
      {
        start: 1500,
        time: 100,
        d: 'M828.82458, 662.503343 C 828.82458, 659.3033429999999, 828.6, 624.959411, 828.8, 614.359411 C 829, 600.0594110000001, 829.5, 585.759411, 830.3, 571.459411 C 832.3, 535.759411, 813, 363.95941100000005, 795.0999999999999, 315.55941100000007 C 811.0732649999999, 321.02218700000003, 822.252186, 301.659411, 805.652186, 292.759411 C 783.8521860000001, 284.359411, 755.2999999999998, 267.1594110000001, 743.7999999999998, 243.95941100000007 C 749.9999999999999, 242.75941100000009, 757.8999999999999, 239.35941100000008, 761.6999999999998, 233.55941100000007 C 788.4999999999998, 188.25941100000006, 616.0999999999998, 204.05941100000007, 603.6999999999998, 207.25941100000006 C 574.3999999999999, 213.15941100000006, 544.8999999999999, 227.25941100000006, 519.7999999999998, 244.55941100000007 C 441.39999999999986, 290.1594110000001, 420.1999999999998, 364.45941100000005, 421.79999999999984, 465.45941100000005 C 421.6999999999998, 465.45941100000005, 415.79999999999984, 525.759411, 417.09999999999985, 555.6594110000001 C 414.1999999999999, 596.5594110000001, 409.393572, 633.349281, 401.893572, 666.049281 C 394.49357200000003, 691.9492809999999, 405.89999999999986, 731.6594110000001, 439.09999999999985, 739.459411 C 432.39999999999986, 782.759411, 434.29999999999984, 851.459411, 491.29999999999984, 837.259411 C 517.1999999999998, 824.759411, 512.877794, 776.904978, 516.077794, 757.304978 C 577.377794, 776.592055, 632.8043580000001, 776.720742, 697.517367, 779.309362 C 700.517367, 813.509362, 698.6999999999999, 840.859411, 708.0999999999999, 852.559411 C 763.8, 893.559411, 782.1999999999999, 810.659411, 779.3999999999999, 774.059411 C 853.10744, 755.313131, 824.82458, 712.2033429999999, 828.82458, 662.503343Z',
      },
      {
        start: 1600,
        time: 100,
        d: 'M827.9, 648.7 C 827.9, 645.5, 828.6, 625.7, 828.8, 615.1 C 829, 600.8000000000001, 829.5, 586.5, 830.3, 572.2 C 832.3, 536.5, 813, 364.70000000000005, 795.0999999999999, 316.30000000000007 C 815.8, 314.20000000000005, 824.14288, 304.69999999999993, 807.54288, 295.79999999999995 C 785.74288, 287.4, 755.2999999999998, 267.9000000000001, 743.7999999999998, 244.70000000000007 C 749.9999999999999, 243.50000000000009, 758.495938, 250.50000000000009, 762.295938, 244.70000000000007 C 789.0959379999999, 199.40000000000006, 616.0999999999998, 204.80000000000007, 603.6999999999998, 208.00000000000006 C 574.3999999999999, 213.90000000000006, 544.8999999999999, 228.00000000000006, 519.7999999999998, 245.30000000000007 C 441.39999999999986, 290.9000000000001, 420.1999999999998, 365.20000000000005, 421.79999999999984, 466.20000000000005 C 421.6999999999998, 466.20000000000005, 415.79999999999984, 526.5, 417.09999999999985, 556.4000000000001 C 414.1999999999999, 597.3000000000001, 403.1999999999999, 625.6000000000001, 395.6999999999999, 658.3000000000001 C 388.2999999999999, 684.2, 405.89999999999986, 732.4000000000001, 439.09999999999985, 740.2 C 432.39999999999986, 783.5, 434.29999999999984, 852.2, 491.29999999999984, 838 C 517.1999999999998, 825.5, 511.79999999999984, 782.5, 514.9999999999999, 762.9 C 576.2999999999998, 773.3, 638.0999999999999, 784.9, 700.4999999999999, 782.4 C 703.4999999999999, 816.6, 698.6999999999999, 841.6, 708.0999999999999, 853.3 C 763.8, 894.3, 782.1999999999999, 811.4, 779.3999999999999, 774.8 C 867.6, 763.3, 823.9, 698.4, 827.9, 648.7Z',
      },
      {
        start: 1700,
        time: 100,
        d: 'M827.9, 648.7 C 827.9, 645.5, 828.6, 625.7, 828.8, 615.1 C 829, 600.8000000000001, 829.5, 586.5, 830.3, 572.2 C 832.3, 536.5, 813, 364.70000000000005, 795.0999999999999, 316.30000000000007 C 815.8, 314.20000000000005, 820.0999999999999, 291.20000000000005, 803.4999999999999, 282.30000000000007 C 781.6999999999999, 273.9000000000001, 755.2999999999998, 267.9000000000001, 743.7999999999998, 244.70000000000007 C 749.9999999999999, 243.50000000000009, 757.8999999999999, 240.10000000000008, 761.6999999999998, 234.30000000000007 C 788.4999999999998, 189.00000000000006, 616.0999999999998, 204.80000000000007, 603.6999999999998, 208.00000000000006 C 574.3999999999999, 213.90000000000006, 544.8999999999999, 228.00000000000006, 519.7999999999998, 245.30000000000007 C 441.39999999999986, 290.9000000000001, 420.1999999999998, 365.20000000000005, 421.79999999999984, 466.20000000000005 C 421.6999999999998, 466.20000000000005, 415.79999999999984, 526.5, 417.09999999999985, 556.4000000000001 C 414.1999999999999, 597.3000000000001, 403.1999999999999, 625.6000000000001, 395.6999999999999, 658.3000000000001 C 388.2999999999999, 684.2, 405.89999999999986, 732.4000000000001, 439.09999999999985, 740.2 C 432.39999999999986, 783.5, 434.29999999999984, 852.2, 491.29999999999984, 838 C 517.1999999999998, 825.5, 511.79999999999984, 782.5, 514.9999999999999, 762.9 C 576.2999999999998, 773.3, 638.0999999999999, 784.9, 700.4999999999999, 782.4 C 703.4999999999999, 816.6, 698.6999999999999, 841.6, 708.0999999999999, 853.3 C 763.8, 894.3, 782.1999999999999, 811.4, 779.3999999999999, 774.8 C 867.6, 763.3, 823.9, 698.4, 827.9, 648.7Z',
      },
    ],
    leftArm: [
      {
        start: 600,
        time: 100,
        d: 'M441.3, 486.5 C 434.3, 399, 346.9, 561.7, 338.1, 583.9 C 313, 635.1, 292.6, 693.4, 308.6, 749.7 C 313, 765.3000000000001, 319.1, 770.6, 330, 771.5 C 347.9, 773, 353.3, 760.6, 353, 746.6 C 350.8, 687, 368.2, 628.1, 403.8, 579.4000000000001 C 429.2, 552.4, 443.4, 527.4, 441.3, 486.5Z',
      },
      {
        start: 800,
        time: 100,
        d: 'M441.21282750096157, 476.49389855211535 C 431.22598314418633, 423.13792745431505, 306.53309788959115, 522.3495445698824, 293.9782078410737, 535.886716665553 C 258.1682373617791, 567.1075820393514, 243.54944151784687, 589.7372370726916, 246.24504733333336, 620.1715803333333 C 249.27548135759207, 632.2817967519126, 255.37138597778323, 651.4434810591847, 270.9223293333333, 651.9922853333334 C 296.4601170456589, 652.9069591235815, 301.87223794862365, 637.8001657089807, 300.1454253333333, 620.1715803333333 C 297.00670282120393, 583.8285417341457, 336.92163857520745, 562.8391043515273, 387.7118755896652, 533.1426952948088 C 423.94985368425006, 516.6785670703447, 444.20888080799426, 501.4340038995443, 441.21282750096157, 476.49389855211535Z',
        move: { x: -25, y: 23.13129866666668 },
      },
      {
        start: 900,
        time: 100,
        d: 'M441.1692412514424, 471.49084782817306 C 429.6889747162795, 435.20689118147254, 287.06260707277625, 500.691046856494, 272.630272, 509.8968049999999 C 231.4653162810582, 531.1281030606975, 189.2422737767703, 576.8175686090376, 189.506798, 598.8648989999999 C 191.52774753638815, 618.9712541278689, 197.60646896667484, 624.4677785887769, 215.482884, 624.8409849999999 C 236.397337568488, 622.8653876853723, 235.45695842293546, 582.5906590634713, 280.423098, 556.65376 C 302.1416982318059, 548.1742551012187, 321.2824578628112, 530.2086565272909, 379.66781338449783, 510.01404294221317 C 421.3247805263751, 498.8178506055171, 444.61332121199143, 488.45100584931646, 441.1692412514424, 471.49084782817306Z',
        move: { x: -12.5, y: 15 },
      },
      {
        start: 1000,
        time: 100,
        d: 'M441.18891536887156, 474.0234720912781 C 414.79710408586334, 455.07347478933036, 308.36622021292476, 509.40239186510587, 294.781333, 520.8007809999999 C 256.0335296994984, 547.0889577435391, 220.0775715674095, 519.1689444011474, 192.175794, 534.438226 C 170.71924410646238, 552.1889373515472, 179.89487370217267, 568.3944431431803, 192.825196, 574.051757 C 214.28877158083566, 583.2641464280338, 246.5392926549861, 579.6164243283107, 268.155845, 573.402355 C 291.7098121967689, 565.2056477594733, 328.34172727059797, 546.7267108976299, 383.29877099561253, 521.7221365341462 C 422.50969545110013, 507.85923082954537, 444.4307634537742, 495.0232070289883, 441.18891536887156, 474.0234720912781Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1100,
        time: 100,
        d: 'M441.20858948630075, 476.5560963543831 C 422.6343074554472, 443.1193533971883, 313.9414063530732, 526.2565858737177, 301.20396700000003, 539.8476059999999 C 243.44304511793848, 593.9217364263809, 223.49520535804862, 532.005777193257, 199.897232, 550.887442 C 180.28986567653664, 569.5295185752253, 202.30343743767054, 593.1969966975836, 214.833482, 604.7878199999999 C 229.05335359318303, 614.7977631706952, 265.92107988703657, 609.4623205931501, 283.020707, 601.540809 C 308.4100411617318, 590.3798884177278, 335.40099667838473, 563.2447652679689, 386.9297286067272, 533.4302301260793 C 423.69461037582516, 516.9006110535736, 444.248205695557, 501.59540820866005, 441.20858948630075, 476.5560963543831Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1200,
        time: 100,
        d: 'M441.23144211472555, 479.04207226578734 C 425.5507305915854, 432.08951504789127, 322.1810547648049, 535.1174394052882, 310.42797525000003, 550.8607044999999 C 232.2585898384539, 644.4792343197857, 242.7474210185365, 575.4669293949426, 215.41149600000003, 603.0537759999999 C 194.6625482574025, 628.0787564314189, 222.7710275782529, 653.2312525231877, 232.29595200000003, 655.6553489999999 C 263.02150669488725, 660.2907953780215, 293.5780756652775, 637.8215936948626, 308.925405, 625.1334489999999 C 327.4174056212989, 601.8627585632959, 343.6007475087886, 583.3549869509767, 391.1472964550454, 544.9226725945596 C 425.07095778186886, 525.7754582901802, 444.0361542716677, 508.04655615649506, 441.23144211472555, 479.04207226578734Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1300,
        time: 100,
        d: 'M441.9036967431503, 478.93043917719154 C 429.11655572772355, 418.4620676985941, 331.0701051765366, 541.3806839368588, 320.3013855, 559.2761939999999 C 255.27598022563586, 655.6396698798571, 248.43357967902432, 628.880971263295, 235.54296300000001, 666.038869 C 231.6192258382683, 687.2727872876127, 244.39234205216854, 693.995303682125, 254.37562499999996, 695.9113679999999 C 280.82599479659143, 699.5016655853476, 298.144449110185, 681.7619067965751, 311.523013, 662.7918579999999 C 324.41648408086587, 641.048842708864, 358.29451933919233, 602.166404300651, 396.01426630336357, 553.8175060630397 C 424.4990991879125, 520.3634575267866, 444.47350484777843, 511.90009510433003, 441.9036967431503, 478.93043917719154Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1400,
        time: 100,
        d: 'M441.60184837157516, 482.7152195885958 C 431.7082778638618, 408.7310338492971, 338.9850525882683, 551.5403419684294, 329.20069275000003, 571.588097 C 284.13799011281793, 645.3698349399285, 276.91090833951216, 656.3243151316475, 278.4656, 703.053264 C 278.70373141913416, 721.4702231438064, 294.90408652608437, 742.4632038410625, 305.345728, 743.871236 C 327.52091289829576, 746.4163847926737, 319.7132120550925, 720.5338483982875, 326.252494, 704.048824 C 331.599229540433, 663.377316354432, 363.24725966959613, 615.1332021503256, 399.9071331516818, 566.6087530315199 C 426.8495495939562, 536.3817287633933, 443.9367524238892, 519.650047552165, 441.60184837157516, 482.7152195885958Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1500,
        time: 100,
        d: 'M441.3, 486.5 C 434.3, 399, 346.9, 561.7, 338.1, 583.9 C 313, 635.1, 292.6, 693.4, 308.6, 749.7 C 313, 765.3000000000001, 319.1, 770.6, 330, 771.5 C 347.9, 773, 353.3, 760.6, 353, 746.6 C 350.8, 687, 368.2, 628.1, 403.8, 579.4000000000001 C 429.2, 552.4, 443.4, 527.4, 441.3, 486.5Z',
      },
    ],
    rightArm: [
      {
        start: 600,
        time: 100,
        d: 'M827.6, 567.9 C 855.9, 633.5, 878.8000000000001, 702.5999999999999, 891.5, 773.0999999999999 C 893.5, 783.4999999999999, 894.1, 796.5999999999999, 902.8, 803.8999999999999 C 942.5999999999999, 825.3999999999999, 931.5, 750.8999999999999, 932.0999999999999, 729.7999999999998 C 927.6999999999999, 628.4999999999999, 885.3999999999999, 532.1999999999998, 820.0999999999999, 455.09999999999985Z',
        move: { x: -6.67249000000003, y: -6.672489999999982 },
      },
      {
        start: 800,
        time: 100,
        d: 'M835.2377908511703, 521.407210339682 C 892.3577216629194, 559.9688503953843, 957.8986691586846, 571.2091365376986, 983.531995, 612.6511429999999 C 999.3975602269778, 631.3326967405377, 986.6146976126422, 661.8620768840451, 1004.1745350000001, 666.153235 C 1028.2033221168763, 673.3067143963044, 1049.3225644427175, 644.5755721779968, 1046.1576767108102, 616.576867733251 C 1037.2768394114553, 557.0297010008946, 951.8996990108558, 500.4216836630275, 820.0999999999993, 455.0999999999999Z',
        move: { x: -18.682972000000063, y: 24.02096400000005 },
      },
      {
        start: 900,
        time: 100,
        d: 'M839.0566862767554, 498.1608155095231 C 910.5865824943791, 523.2032755930763, 983.9917582380269, 540.227445306548, 1016.091747, 567.140455 C 1043.4745083404669, 594.2807991108067, 1033.3005519189633, 611.3999588260677, 1055.290308, 614.186696 C 1084.3597161753141, 617.3115125944568, 1089.7861950978609, 590.1166946671186, 1078.460505, 555.629288 C 1067.3392490509677, 516.9585379014653, 985.1495485162837, 484.53252549454135, 820.0999999999991, 455.0999999999999Z',
        move: { x: 0, y: 10 },
      },
      {
        start: 1000,
        time: 100,
        d: 'M837.4621801545818, 510.11267698612744 C 902.9754732712031, 542.1058650206137, 935.293109604908, 560.4373198836709, 963.6087610000001, 576.790873 C 1000.4490857078873, 594.238217785955, 1018.2963880206845, 593.7644724290884, 1040.542899, 593.533204 C 1072.0323866869785, 594.6331142978872, 1113.3565995876343, 567.3482808830441, 1107.525834, 540.452387 C 1076.5188606426427, 500.1452189406499, 1052.1278032125579, 602.4417969612629, 820.0999999999991, 455.09999999999985Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1100,
        time: 100,
        d: 'M834.7677701236654, 521.670141588902 C 892.8384046169624, 560.3846920164909, 937.3204414839264, 577.1161157069366, 965.8631150000001, 587.357336 C 998.3451345663098, 597.6809598287639, 1023.7122678165476, 600.6785139432708, 1041.564371, 600.381209 C 1098.0881261495833, 596.2305062383099, 1123.5819484701078, 531.5174961064353, 1100.985788, 515.72604 C 1053.883207314114, 485.19619615252, 1066.8997905700464, 652.6988065690103, 819.3780259999992, 455.09999999999985Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1200,
        time: 100,
        d: 'M832.975827592749, 533.2276061916765 C 883.6038034627218, 578.6635190123682, 934.9126493629449, 614.3343045302025, 957.0421350000001, 621.600244 C 984.0112174247324, 633.2790868715729, 1032.1779186124108, 647.234821457453, 1045.7672630000002, 644.392021 C 1088.6238226121882, 639.3684006787323, 1119.8829603525805, 597.8759563298265, 1092.164808, 567.876772 C 1052.551449985585, 530.6686528643899, 1087.2298264275348, 700.1966381767577, 819.5585194999994, 455.09999999999985Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1300,
        time: 100,
        d: 'M831.1838850618327, 544.785070794451 C 874.3692023084811, 596.9423460082454, 915.4075422419631, 637.4441663534683, 939.182999, 661.424319 C 959.4693679498215, 680.2322599143819, 982.3958934082739, 689.0313769716353, 995.671945, 694.8354639999999 C 1023.4671074081252, 703.919004452488, 1051.5291699017207, 695.8559615532176, 1040.7942130000001, 666.246546 C 1019.7451813237237, 631.4650202429266, 966.8002876183564, 644.632879784505, 819.7390129999995, 455.09999999999985Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1400,
        time: 100,
        d: 'M828.8891895309164, 556.3425353972254 C 892.2255516175233, 639.7999961575687, 913.4861134099918, 671.7209060120495, 915.912411, 721.4254659999999 C 914.0718744749108, 748.2586479571909, 913.6868492041372, 771.5346644858176, 927.945403, 768.881992 C 955.9352812040627, 767.3314242262439, 980.8944979508601, 727.3053687766087, 970.2444654999999, 686.4643019999999 C 937.1562461618618, 596.7407346214633, 925.5973908091781, 588.4164398922524, 819.4167534999997, 455.09999999999985Z',
        move: { x: 0, y: 0 },
      },
      {
        start: 1500,
        time: 100,
        d: 'M827.6, 567.9 C 855.9, 633.5, 878.8000000000001, 702.5999999999999, 891.5, 773.0999999999999 C 893.5, 783.4999999999999, 894.1, 796.5999999999999, 902.8, 803.8999999999999 C 942.5999999999999, 825.3999999999999, 931.5, 750.8999999999999, 932.0999999999999, 729.7999999999998 C 927.6999999999999, 628.4999999999999, 885.3999999999999, 532.1999999999998, 820.0999999999999, 455.09999999999985Z',
      },
    ],
    leftEyeWhite: [
      {
        start: 300,
        time: 100,
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1700,
        time: 100,
        d: 'M559.3, 351.5 C 543.1999999999999, 305, 463.19999999999993, 339, 492.79999999999995, 394.2 C 517.7, 429.1, 584.4, 409.3, 559.3, 351.5Z',
      },
      {
        start: 1800,
        time: 100,
        d: 'M559.3, 372.8590834510398 C 543.1999999999999, 359.3086813351318, 463.19999999999993, 369.21650223708605, 492.79999999999995, 385.3021408779059 C 517.7, 395.47222762726483, 584.4, 389.7023789843621, 559.3, 372.8590834510398Z',
      },
      {
        start: 1900,
        time: 100,
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 2000,
        time: 100,
        d: 'M559.3,351.5 C543.1999999999999,305,463.19999999999993,339,492.79999999999995,394.2 C517.7,429.1,584.4,409.3,559.3,351.5Z',
      },
    ],
    rightEyeWhite: [
      {
        start: 300,
        time: 100,
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1700,
        time: 100,
        d: 'M735.9, 403.8 C 759.3, 363.8, 703.3, 297.6, 662.8, 355.8 C 633.9, 403.8, 702.1, 451.3, 735.9, 403.8Z',
      },
      {
        start: 1800,
        time: 100,
        d: 'M735.9, 391.3668377054369 C 759.3, 380.0122197629587, 703.3, 361.2203270681572, 662.8, 377.7412961744631 C 633.9, 391.3668377054369, 702.1, 404.8504465121299, 735.9, 391.3668377054369Z',
      },
      {
        start: 1900,
        time: 100,
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 2000,
        time: 100,
        d: 'M735.9,403.8 C759.3,363.8,703.3,297.6,662.8,355.8 C633.9,403.8,702.1,451.3,735.9,403.8Z',
      },
    ],
    leftIris: [
      {
        start: 300,
        time: 100,
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1700,
        time: 100,
        d: 'M571.3, 366.8 C 567.8, 310.3, 499.09999999999997, 335.7, 509.19999999999993, 383.6 C 523.5, 422.7, 577.9, 413, 571.3, 366.8Z',
      },
      {
        start: 1800,
        time: 100,
        d: 'M571.3, 376.97433368874044 C 567.8, 358.6252084549797, 499.09999999999997, 366.8741957282102, 509.19999999999993, 382.4303567670975 C 523.5, 395.12860095541697, 577.9, 391.9783971542227, 571.3, 376.97433368874044Z',
      },
      {
        start: 1900,
        time: 100,
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 2000,
        time: 100,
        d: 'M571.3,366.8 C567.8,310.3,499.09999999999997,335.7,509.19999999999993,383.6 C523.5,422.7,577.9,413,571.3,366.8Z',
      },
    ],
    rightIris: [
      {
        start: 300,
        time: 100,
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1700,
        time: 100,
        d: 'M743.2, 387.2 C 752.1, 332.4, 678.7, 320.29999999999995, 673.2, 381.09999999999997 C 671.9, 419.2, 736.8, 427.3, 743.2, 387.2Z',
      },
      {
        start: 1800,
        time: 100,
        d: 'M743.2, 387.1161860665065 C 752.1, 372.9662904750608, 678.7, 369.841952214906, 673.2, 385.5411064477506 C 671.9, 395.37889882063524, 736.8, 397.47039798652406, 743.2, 387.1161860665065Z',
      },
      {
        start: 1900,
        time: 100,
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 2000,
        time: 100,
        d: 'M743.2,387.2 C752.1,332.4,678.7,320.29999999999995,673.2,381.09999999999997 C671.9,419.2,736.8,427.3,743.2,387.2Z',
      },
    ],
    leftPupil: [
      {
        start: 300,
        time: 100,
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1700,
        time: 100,
        d: 'M553.2, 368.3 C 552.9000000000001, 365.6, 551.7, 362.90000000000003, 549.7, 361.2 C 545.6, 357.5, 539.9000000000001, 358.3, 536.7, 362.2 C 535.5, 363.5, 534.7, 365.09999999999997, 534.3000000000001, 366.7 C 534.0000000000001, 367.5, 533.8000000000001, 368.3, 533.8000000000001, 369.2 C 533.8000000000001, 370.5, 533.9000000000001, 371.59999999999997, 534.3000000000001, 372.7 C 534.9000000000001, 375.4, 536.4000000000001, 377.9, 539.1, 379.4 C 544.3000000000001, 382.4, 551.1, 380, 552.9, 374.2 C 553.1999999999999, 373.2, 553.3, 372.09999999999997, 553.3, 371 C 553.4, 370.1, 553.4, 369.2, 553.2, 368.3Z',
      },
      {
        start: 1800,
        time: 100,
        d: 'M553.2, 375.3349069546475 C 552.9000000000001, 374.1671260297609, 551.7, 372.99934510487424, 549.7, 372.2640756336493 C 545.6, 370.66378325510107, 539.9000000000001, 371.00979241803043, 536.7, 372.69658708731106 C 535.5, 373.25885197707134, 534.7, 373.95087030292984, 534.3000000000001, 374.6428886287888 C 534.0000000000001, 374.98889779171816, 533.8000000000001, 375.3349069546475, 533.8000000000001, 375.72416726294296 C 533.8000000000001, 376.2864321527031, 533.9000000000001, 376.76219475173116, 534.3000000000001, 377.23795735075885 C 534.9000000000001, 378.4057382756455, 536.4000000000001, 379.48701690979976, 539.1, 380.1357840902922 C 544.3000000000001, 381.4333184512775, 551.1, 380.3952909624894, 552.9, 377.8867245312515 C 553.1999999999999, 377.45421307758977, 553.3, 376.97845047856185, 553.3, 376.50268787953416 C 553.4, 376.1134275712385, 553.4, 375.72416726294296, 553.2, 375.3349069546475Z',
      },
      {
        start: 1900,
        time: 100,
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 2000,
        time: 100,
        d: 'M553.2,368.3 C552.9000000000001, 365.6, 551.7, 362.90000000000003, 549.7, 361.2 C545.6, 357.5, 539.9000000000001, 358.3, 536.7, 362.2 C535.5, 363.5, 534.7, 365.09999999999997, 534.3000000000001, 366.7 C534.0000000000001, 367.5, 533.8000000000001, 368.3, 533.8000000000001, 369.2 C533.8000000000001, 370.5, 533.9000000000001, 371.59999999999997, 534.3000000000001, 372.7 C534.9000000000001, 375.4, 536.4000000000001, 377.9, 539.1, 379.4 C544.3000000000001, 382.4, 551.1, 380, 552.9, 374.2 C553.1999999999999, 373.2, 553.3, 372.09999999999997, 553.3, 371 C553.4, 370.1, 553.4, 369.2, 553.2, 368.3Z',
      },
    ],
    rightPupil: [
      {
        start: 300,
        time: 100,
        attr: { 'fill-opacity': 0 },
      },
      {
        start: 1700,
        time: 100,
        d: 'M719, 376.7 C 719.5, 375.59999999999997, 719.8, 374.3, 719.8, 373.09999999999997 C 719.9, 368.49999999999994, 716.5, 364.4, 712.0999999999999, 363.29999999999995 C 710.1999999999999, 362.79999999999995, 708.3999999999999, 362.99999999999994, 706.8, 363.69999999999993 C 704, 364.29999999999995, 701.5, 366.29999999999995, 700.1999999999999, 368.99999999999994 C 698.1999999999999, 373.19999999999993, 699.1999999999999, 378.09999999999997, 702.5999999999999, 381.29999999999995 C 706.0999999999999, 384.59999999999997, 711.8999999999999, 385.49999999999994, 715.6999999999999, 382.09999999999997 C 716.4999999999999, 381.4, 717.0999999999999, 380.59999999999997, 717.5999999999999, 379.7 C 717.6999999999999, 379.5, 717.8999999999999, 379.3, 717.9999999999999, 379.2 C 718.4, 378.3, 718.7, 377.5, 719, 376.7Z',
      },
      {
        start: 1800,
        time: 100,
        d: 'M719, 379.62001720268455 C 719.5, 378.94531125523866, 719.8, 378.1479314991664, 719.8, 377.41188864740735 C 719.9, 374.5903910489975, 716.5, 372.075577972154, 712.0999999999999, 371.4008720247081 C 710.1999999999999, 371.0941875031419, 708.3999999999999, 371.21686131176847, 706.8, 371.6462196419612 C 704, 372.01424106784077, 701.5, 373.24097915410584, 700.1999999999999, 374.89707557056386 C 698.1999999999999, 377.4732255517205, 699.1999999999999, 380.47873386307003, 702.5999999999999, 382.4415148010943 C 706.0999999999999, 384.4656326434317, 711.8999999999999, 385.0176647822511, 715.6999999999999, 382.93221003560024 C 716.4999999999999, 382.50285170540747, 717.0999999999999, 382.0121564709014, 717.5999999999999, 381.46012433208216 C 717.6999999999999, 381.3374505234557, 717.8999999999999, 381.21477671482916, 717.9999999999999, 381.1534398105159 C 718.4, 380.60140767169656, 718.7, 380.1107124371906, 719, 379.62001720268455Z',
      },
      {
        start: 1900,
        time: 100,
        attr: { 'fill-opacity': 1 },
      },
      {
        start: 2000,
        time: 100,
        d: 'M719,376.7 C719.5, 375.59999999999997, 719.8, 374.3, 719.8, 373.09999999999997 C719.9, 368.49999999999994, 716.5, 364.4, 712.0999999999999, 363.29999999999995 C710.1999999999999, 362.79999999999995, 708.3999999999999, 362.99999999999994, 706.8, 363.69999999999993 C704, 364.29999999999995, 701.5, 366.29999999999995, 700.1999999999999, 368.99999999999994 C698.1999999999999, 373.19999999999993, 699.1999999999999, 378.09999999999997, 702.5999999999999, 381.29999999999995 C706.0999999999999, 384.59999999999997, 711.8999999999999, 385.49999999999994, 715.6999999999999, 382.09999999999997 C716.4999999999999, 381.4, 717.0999999999999, 380.59999999999997, 717.5999999999999, 379.7 C717.6999999999999, 379.5, 717.8999999999999, 379.3, 717.9999999999999, 379.2 C718.4, 378.3, 718.7, 377.5, 719, 376.7Z',
      },
    ],
    eyelids: [
      {
        start: 300,
        time: 100,
        attr: { opacity: 1 },
      },
      {
        start: 700,
        time: 100,
        move: { x: 1.9444604399999434, y: -8.90568503499992 },
      },
      {
        start: 1000,
        time: 100,
        move: { x: 1.944460439998693, y: 47.228182230000186 },
      },
      {
        start: 1100,
        time: 100,
        move: { x: 1.944460439999034, y: 40.91955652000017 },
      },
      {
        start: 1300,
        time: 100,
        move: { x: -5.83338131999767, y: -79.24205371500044 },
      },
      {
        start: 1900,
        time: 100,
        attr: { opacity: 0 },
      },
    ],
    eyebrows: [
      {
        start: 700,
        time: 100,
        move: { x: 3.227326215000062, y: -9.875278999999978 },
      },
      {
        start: 1000,
        time: 100,
        move: { x: 1.5535416777984121, y: 74.62120142500032 },
      },
      {
        start: 1100,
        time: 100,
        move: { x: 0.9924861818655717, y: 52.997116956666844 },
      },
      {
        start: 1300,
        time: 100,
        move: { x: -5.773354074664046, y: -117.74303938166719 },
      },
    ],
    lipsClosed: [
      {
        start: 300,
        time: 200,
        d: 'M558.6 429.9 C 561.2 435.29999999999995, 564.9 440.09999999999997, 569.5 443.9 C 570.9 445.09999999999997, 572.4 446.2, 574.2 446.79999999999995 C 577.9000000000001 448.09999999999997, 582.1 446.99999999999994, 585.9000000000001 446.09999999999997 C 594.9000000000001 443.9, 604.6000000000001 442.7, 613.2 445.99999999999994 C 616.2 447.19999999999993, 619.1 448.8999999999999, 622.2 449.79999999999995 C 629.4000000000001 452.09999999999997, 637.5 450.29999999999995, 644.1 446.49999999999994 C 650.7 442.69999999999993, 655.9 436.99999999999994, 660.8000000000001 431.09999999999997 Z',
      },
      {
        start: 400,
        time: 100,
        attr: { 'stroke-opacity': 0 },
      },
      {
        start: 1800,
        time: 200,
        d: 'M558.6 441.0873888101382 C 561.2 443.5996144060143, 564.9 445.832703824571, 569.5 447.6005662809283 C 570.9 448.1588386355675, 572.4 448.6705882939867, 574.2 448.9497244713063 C 577.9000000000001 449.5545195221654, 582.1 449.0427698637462, 585.9000000000001 448.6240655977668 C 594.9000000000001 447.6005662809283, 604.6000000000001 447.0422939262892, 613.2 448.57754290154685 C 616.2 449.135815256186, 619.1 449.92670109192477, 622.2 450.34540535790416 C 629.4000000000001 451.4154273709625, 637.5 450.5780188390038, 644.1 448.8101563826464 C 650.7 447.0422939262891, 655.9 444.39050024175316, 660.8000000000001 441.6456611647773 Z',
      },
      {
        start: 1900,
        time: 100,
        attr: { 'stroke-opacity': 1 },
      },
    ],
    mouthOpen: [
      {
        start: 400,
        time: 100,
        attr: { opacity: 1 },
      },
      {
        start: 700,
        time: 100,
        move: { x: 0.8396907299999157, y: -10.066587060000018 },
      },
      {
        start: 1000,
        time: 100,
        move: { x: 4.66083164999975, y: 43.43914795000018 },
      },
      {
        start: 1200,
        time: 100,
        move: { x: 1.8119209549998345, y: 17.30574207500021 },
      },
      {
        start: 1300,
        time: 100,
        move: { x: -7.3124433349995, y: -50.67830296500037 },
      },
      {
        start: 1900,
        time: 100,
        attr: { opacity: 0 },
      },
    ],
    sticker: [
      {
        start: 700,
        time: 100,
        move: { x: 0.8396907299999157, y: -10.066587060000018 },
      },
      {
        start: 1000,
        time: 100,
        move: { x: 4.66083164999975, y: 43.43914795000018 },
      },
      {
        start: 1200,
        time: 100,
        move: { x: 1.8119209549998345, y: 17.30574207500021 },
      },
      {
        start: 1300,
        time: 100,
        move: { x: -7.3124433349995, y: -50.67830296500037 },
      },
    ],
  };

  _.forEach(animations, (times, id) => createAnimationForElement(blobEl, timeline, times, id));

  return 2400;
};
